webpackJsonp([1],{

/***/ 100:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wikijs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_wikijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_wikijs__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var wikiApi = __WEBPACK_IMPORTED_MODULE_1_wikijs___default()({ apiUrl: 'https://en.wikipedia.org/w/api.php' });
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wiki-summary',
  props: ['selected'],
  watch: {
    selected: function selected() {
      this.loading = true;
      this.$asyncComputed.imageUrl.update();
      this.$asyncComputed.info.update();
      this.$asyncComputed.text.update();
    },
    imageUrl: function imageUrl() {
      var _this = this;

      console.log('image watch called');
      if (Array.isArray(this.imageUrl)) {
        var filtered = this.imageUrl.filter(function (img) {
          return img.match(new RegExp(_this.info.image + '$', 'i'));
        });
        if (filtered) {
          this.imageUrl = filtered.pop();
        }
      } else if (!this.imageUrl) {
        this.imageUrl = 'https://via.placeholder.com/400?text=No+Image+Found';
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },

  asyncComputed: {
    resultsImage: function resultsImage() {
      var img = 'static/results/' + this.selected + '.png';
      return img;
    },
    imageUrl: function imageUrl() {
      var _this2 = this;

      if (!this.selected) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('');
      return wikiApi.page(this.selected).then(function (x) {
        return x.mainImage();
      }).catch(function (reason) {
        console.log('main image failed: ' + reason);
        return wikiApi.page(_this2.selected).then(function (page) {
          return page.images();
        });
      });
    },
    info: function info() {
      if (!this.selected) return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve({});
      return wikiApi.page(this.selected).then(function (x) {
        return x.info();
      }).catch(function (reason) {
        console.log('page info failed' + reason);
      });
    },
    text: function text() {
      var vm = this;
      if (!this.selected) {
        vm.loading = false;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('');
      }
      return wikiApi.page(this.selected).then(function (x) {
        vm.loading = false;
        return x.summary();
      }).catch(function () {
        vm.loading = false;
        return '';
      });
    }
  }
});

/***/ }),

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resize_directive__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resize_directive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_resize_directive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__euclidean_layout__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__euclidean_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__euclidean_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__circular_layout__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__circular_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__circular_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__radial_layout__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__radial_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__radial_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__d3_utils__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__d3_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__d3_utils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_d3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_d3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_d3_hierarchy__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_d3_scale_chromatic__ = __webpack_require__(196);




//
//
//
//










__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(__WEBPACK_IMPORTED_MODULE_9_d3__, __WEBPACK_IMPORTED_MODULE_10_d3_hierarchy__, __WEBPACK_IMPORTED_MODULE_11_d3_scale_chromatic__);

var _layout = {
  euclidean: __WEBPACK_IMPORTED_MODULE_5__euclidean_layout___default.a,
  circular: __WEBPACK_IMPORTED_MODULE_6__circular_layout___default.a,
  radial: __WEBPACK_IMPORTED_MODULE_7__radial_layout___default.a
};

var i = 0;
var currentSelected = null;
var types = ['tree', 'cluster'];
var layouts = ['circular', 'euclidean', 'radial'];

var props = {
  data: Object,
  duration: {
    type: Number,
    default: 750
  },
  type: {
    type: String,
    default: 'tree',
    validator: function validator(value) {
      return types.indexOf(value) !== -1;
    }
  },
  layoutType: {
    type: String,
    default: 'euclidean',
    validator: function validator(value) {
      return layouts.indexOf(value) !== -1;
    }
  },
  color: {
    type: Function,
    default: __WEBPACK_IMPORTED_MODULE_9_d3__["scaleOrdinal"]().domain(['Bacteria', 'Eukaryota', 'Archaea']).range(__WEBPACK_IMPORTED_MODULE_9_d3__["schemeCategory10"])
  },
  marginX: {
    type: Number,
    default: 20
  },
  marginY: {
    type: Number,
    default: 20
  },
  nodeText: {
    type: String,
    required: true
  },
  person: {
    type: String,
    default: 'main'
  },
  identifier: {
    type: Function,
    default: function _default() {
      return i++;
    }
  },
  ramp: { // color ramp used for vis, will work for one of these https://github.com/d3/d3-scale-chromatic
    String: String,
    default: 'interpolateRdYlBu'
  },
  zoomable: {
    type: Boolean,
    default: false
  }
};

var directives = {
  resize: __WEBPACK_IMPORTED_MODULE_4_vue_resize_directive___default.a
};

function hasChildren(d) {
  return d.children || d._children;
}

function getChildren(d) {
  return d.children ? { children: d.children, visible: true } : d._children ? { children: d._children, visible: false } : null;
}

function onAllChilddren(d, callback) {
  var fatherVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  if (callback(d, fatherVisible) === false) {
    return;
  }
  var directChildren = getChildren(d);
  directChildren && directChildren.children.forEach(function (child) {
    return onAllChilddren(child, callback, directChildren.visible);
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'D3Tree',

  props: props,

  directives: directives,

  data: function data() {
    return {
      currentTransform: null,
      maxTextLenght: {
        first: 0,
        last: 0
      }
    };
  },
  mounted: function mounted() {
    var size = this.getSize();
    var svg = __WEBPACK_IMPORTED_MODULE_9_d3__["select"](this.$el).append('svg').attr('width', size.width).attr('height', size.height);
    if (size.width === 400) {
      svg = svg.attr('viewBox', '-300 -270 1000 1000'); // kinda a hack to make it more usable on mobile devices
    }

    var g = null;
    var zoom = null;

    if (this.zoomable) {
      g = svg.append('g');
      zoom = __WEBPACK_IMPORTED_MODULE_9_d3__["zoom"]().scaleExtent([0.9, 8]).on('zoom', this.zoomed(g));
      svg.call(zoom).on('wheel', function () {
        return __WEBPACK_IMPORTED_MODULE_9_d3__["event"].preventDefault();
      });
      svg.call(zoom.transform, __WEBPACK_IMPORTED_MODULE_9_d3__["zoomIdentity"]);
    } else {
      g = this.transformSvg(svg.append('g'), size);
    }

    var tree = this.tree;
    this.internaldata = {
      svg: svg,
      g: g,
      tree: tree,
      zoom: zoom
    };

    this.data && this.onData(this.data);
  },


  methods: {
    getSize: function getSize() {
      var width = this.$el.clientWidth;
      var height = this.$el.clientHeight;
      return { width: width, height: height };
    },
    resize: function resize() {
      var size = this.getSize();
      this.internaldata.svg.attr('width', size.width).attr('height', size.height);
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      this.applyZoom(size);
      this.redraw();
    },
    completeRedraw: function completeRedraw(_ref) {
      var _ref$margin = _ref.margin,
          margin = _ref$margin === undefined ? null : _ref$margin,
          _ref$layout = _ref.layout,
          layout = _ref$layout === undefined ? null : _ref$layout;

      var size = this.getSize();
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      this.applyTransition(size, { margin: margin, layout: layout });
      this.redraw();
    },
    transformSvg: function transformSvg(g, size) {
      size = size || this.getSize();
      return this.layout.transformSvg(g, this.margin, size, this.maxTextLenght);
    },
    updateTransform: function updateTransform(g, size) {
      size = size || this.getSize();
      return this.layout.updateTransform(g, this.margin, size, this.maxTextLenght);
    },
    updateGraph: function updateGraph(source) {
      var _this = this;

      var originBuilder = source;
      var forExit = source;
      if ((typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(source)) === 'object') {
        var origin = { x: source.x0, y: source.y0 };
        originBuilder = function originBuilder(d) {
          return origin;
        };
        forExit = function forExit(d) {
          return { x: source.x, y: source.y };
        };
      }

      var root = this.internaldata.root;
      var links = this.internaldata.g.selectAll('.linktree').data(this.internaldata.tree(root).descendants().slice(1), function (d) {
        return d.id;
      });

      var updateLinks = links.enter().append('path').attr('class', 'linktree');
      var node = this.internaldata.g.selectAll('.nodetree').data(root.descendants(), function (d) {
        return d.id;
      });
      var newNodes = node.enter().append('g').attr('class', 'nodetree');
      var allNodes = newNodes.merge(node);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["removeTextAndGraph"])(node);

      var text = allNodes.append('text').attr('dy', '.35em').text(function (d) {
        var name = d.data[_this.nodeText];
        if (hasChildren(d)) return '';
        return name.length > 15 ? name.substring(0, 15) + '...' : name;
      }).on('click', function (d) {
        currentSelected = currentSelected === d ? null : d;
        _this.mouseovered(false)(d);
        __WEBPACK_IMPORTED_MODULE_9_d3__["event"].stopPropagation();
        _this.redraw();
        _this.$emit('clicked', { element: d, data: d.data });
      }).on('mouseover', function (d) {
        _this.mouseovered(true)(d);
        _this.$emit('hover', { active: true, data: d.data, event: __WEBPACK_IMPORTED_MODULE_9_d3__["event"] });
      }).on('mousemove', function (d) {
        _this.$emit('hover', { active: true, data: d.data, event: __WEBPACK_IMPORTED_MODULE_9_d3__["event"] });
      }).on('mouseout', function (d) {
        _this.mouseovered(false)(d);
        _this.$emit('hover', { active: false });
      });

      // Tip circles instead of rectangles
      allNodes.append('circle').attr('r', function (d) {
        return hasChildren(d) ? 0 : 3;
      }).attr('fill', 'none').attr('stroke', function (d) {
        return __WEBPACK_IMPORTED_MODULE_9_d3__[_this.ramp](d.data.scaled_estimate);
      }).attr('stroke-width', 1).attr('opacity', function (d) {
        return hasChildren(d) ? 0 : 1;
      });

      // branch coloring
      updateLinks.each(function (d) {
        d.linkExtensionNode = this;
      }).attr('d', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["drawLink"])(originBuilder(d), originBuilder(d), _this.layout);
      }).attr('stroke', function (x) {
        return x.color ? x.color : '#AAAAAA';
      });

      var updateAndNewLinks = links.merge(updateLinks);
      var updateAndNewLinksPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["toPromise"])(updateAndNewLinks.transition().duration(this.duration).attr('d', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["drawLink"])(d, d.parent, _this.layout);
      }));

      var exitingLinksPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["toPromise"])(links.exit().transition().duration(this.duration).attr('d', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["drawLink"])(forExit(d), forExit(d), _this.layout);
      }).remove());

      newNodes.attr('transform', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["translate"])(originBuilder(d), _this.layout);
      });

      allNodes.classed('node--internal', function (d) {
        return hasChildren(d);
      }).classed('node--leaf', function (d) {
        return !hasChildren(d);
      }).classed('selected', function (d) {
        return d === currentSelected;
      }).on('click', this.onNodeClick);

      var allNodesPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["toPromise"])(allNodes.transition().duration(this.duration).attr('transform', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["translate"])(d, _this.layout);
      }).attr('opacity', 1));
      // the outter circle
      // this is where we color the nodes
      allNodes.append('circle').attr('fill', function (d) {
        return __WEBPACK_IMPORTED_MODULE_9_d3__[_this.ramp](d.data.scaled_estimate);
      });

      text.attr('x', function (d) {
        return d.textInfo ? d.textInfo.x : 0;
      }).attr('dx', function (d) {
        return d.textInfo ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["anchorTodx"])(d.textInfo.anchor, this) : 0;
      }).attr('transform', function (d) {
        return 'rotate(' + (d.textInfo ? d.textInfo.rotate : 0) + ')';
      });

      var transformText = this.layout.transformText;

      allNodes.each(function (d) {
        d.textInfo = transformText(d, hasChildren(d));
      });

      var textTransition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["toPromise"])(text.transition().duration(this.duration).attr('x', function (d) {
        return d.textInfo.x;
      }).attr('dx', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["anchorTodx"])(d.textInfo.anchor, this);
      }).attr('transform', function (d) {
        return 'rotate(' + d.textInfo.rotate + ')';
      }));

      allNodes.each(function (d) {
        d.x0 = d.x;
        d.y0 = d.y;
      });

      var exitingNodes = node.exit();
      var exitingNodesPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["toPromise"])(exitingNodes.transition().duration(this.duration).attr('transform', function (d) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["translate"])(forExit(d), _this.layout);
      }).attr('opacity', 0).remove());
      exitingNodes.select('circle').attr('r', 1e6);

      allNodes.selectAll('image').remove();
      allNodes.selectAll('.group-arc').remove();

      // const internalNodes = allNodes.filter(d => hasChildren(d) && d.depth > 0)

      // 1. Identify ALL taxonomic groups (including singletons) in circular order
      var leaves = root.leaves();
      var allGroups = [];
      var currentGroup = [];
      var lastOrder = null;

      leaves.forEach(function (leaf, idx) {
        var seenData = _this.$parent.seen[leaf.data[_this.nodeText]];
        var order = seenData ? seenData.Order : 'Unknown';

        if (order === lastOrder) {
          currentGroup.push(leaf);
        } else {
          if (currentGroup.length > 0) {
            allGroups.push({ order: lastOrder, leaves: currentGroup });
          }
          currentGroup = [leaf];
          lastOrder = order;
        }

        if (idx === leaves.length - 1) {
          allGroups.push({ order: lastOrder, leaves: currentGroup });
        }
      });

      // 2. Draw connected arcs and pictograms once for all groups
      allGroups.forEach(function (groupData, idx) {
        var order = groupData.order,
            groupLeaves = groupData.leaves;

        var angles = groupLeaves.map(function (l) {
          return l.x;
        });

        // Calculate mid-points between groups for seamless ring
        var minAngle = void 0,
            maxAngle = void 0;

        // Previous neighbor
        var prevGroup = allGroups[(idx - 1 + allGroups.length) % allGroups.length];
        var prevMax = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(prevGroup.leaves.map(function (l) {
          return l.x;
        })));
        if (idx === 0 && prevMax > Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles))) {
          minAngle = (prevMax - 360 + Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles))) / 2;
        } else {
          minAngle = (prevMax + Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles))) / 2;
        }

        // Next neighbor
        var nextGroup = allGroups[(idx + 1) % allGroups.length];
        var nextMin = Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(nextGroup.leaves.map(function (l) {
          return l.x;
        })));
        if (idx === allGroups.length - 1 && nextMin < Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles))) {
          maxAngle = (Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles)) + 360 + nextMin) / 2;
        } else {
          maxAngle = (Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles)) + nextMin) / 2;
        }

        var midAngle = (Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles)) + Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(angles))) / 2;
        var radius = groupLeaves[0].y + 80;

        // Draw arc
        var arcGenerator = __WEBPACK_IMPORTED_MODULE_9_d3__["arc"]().innerRadius(radius - 4).outerRadius(radius + 4).startAngle(minAngle * Math.PI / 180).endAngle(maxAngle * Math.PI / 180);

        var avgEffect = __WEBPACK_IMPORTED_MODULE_9_d3__["mean"](groupLeaves, function (l) {
          return l.data.scaled_estimate;
        });
        var arcColor = __WEBPACK_IMPORTED_MODULE_9_d3__[_this.ramp](avgEffect);

        _this.internaldata.g.append('path').attr('class', 'group-arc').attr('d', arcGenerator()).attr('fill', arcColor).attr('stroke', '#333').attr('stroke-width', 0.5).attr('opacity', 0.8).style('cursor', 'pointer').on('click', function () {
          _this.$emit('clicked', { data: { name: order } });
        }).on('mouseover', function () {
          _this.$emit('hover', {
            active: true,
            data: { name: order, isGroup: true, taxonomy: 'Group: ' + order + ' (' + groupLeaves.length + ' families)' },
            event: __WEBPACK_IMPORTED_MODULE_9_d3__["event"]
          });
        }).on('mouseout', function () {
          _this.$emit('hover', { active: false });
        });

        // Add pictogram and text for groups >= 2
        if (groupLeaves.length >= 2 && order !== 'Unknown') {
          // Determine size based on angular distance to neighbors
          var d1 = Math.abs(midAngle - (Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(prevGroup.leaves.map(function (l) {
            return l.x;
          }))) + Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(prevGroup.leaves.map(function (l) {
            return l.x;
          })))) / 2);
          var d2 = Math.abs(midAngle - (Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(nextGroup.leaves.map(function (l) {
            return l.x;
          }))) + Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(nextGroup.leaves.map(function (l) {
            return l.x;
          })))) / 2);
          var minAngularDist = Math.min(d1 > 180 ? 360 - d1 : d1, d2 > 180 ? 360 - d2 : d2);

          var innerTextOffset = -30;
          var outerTextOffset = 20;
          var isSmall = minAngularDist < 3;
          var imgSize = isSmall ? 30 : 50;
          var fontSize = isSmall ? '7px' : '10px';
          var textOffset = isSmall ? outerTextOffset : innerTextOffset;

          if (['Saxifragales', 'Perciformes'].includes(order)) {
            textOffset = innerTextOffset;
          } else if (order === 'Tetraodontiformes') {
            textOffset = outerTextOffset;
          }

          var midRad = (midAngle - 90) * Math.PI / 180;
          var iconX = (radius + 45) * Math.cos(midRad);
          var iconY = (radius + 45) * Math.sin(midRad);

          var group = _this.internaldata.g.append('g').attr('class', 'group-arc');
          group.append('image').attr('width', imgSize).attr('height', imgSize).attr('xlink:href', 'static/Vectors/' + order + '.svg').attr('x', iconX - imgSize / 2).attr('y', iconY - imgSize / 2).style('cursor', 'pointer').on('click', function () {
            _this.$emit('clicked', { data: { name: order } });
          }).on('mouseover', function () {
            _this.$emit('hover', {
              active: true,
              data: { name: order, isGroup: true, taxonomy: 'Group: ' + order + ' (' + groupLeaves.length + ' families)' },
              event: __WEBPACK_IMPORTED_MODULE_9_d3__["event"]
            });
          }).on('mouseout', function () {
            _this.$emit('hover', { active: false });
          }).on('error', function () {
            __WEBPACK_IMPORTED_MODULE_9_d3__["select"](this).remove();
          });

          // Only show group text when group has more than 3 taxons
          if (groupLeaves.length > 2) {
            group.append('text').attr('x', iconX).attr('y', iconY).attr('text-anchor', 'middle').attr('font-size', fontSize).attr('font-weight', 'bold').attr('fill', 'var(--text-color)').attr('transform', function () {
              var rotation = midAngle;
              var translateY = textOffset;
              if (rotation > 90 && rotation < 270) {
                rotation -= 180;
                translateY = textOffset;
              } else {
                translateY = -textOffset;
              }
              return 'rotate(' + rotation + ', ' + iconX + ', ' + iconY + ') translate(0, ' + translateY + ')';
            }).text(order);
          }
        }
      });

      var extremeNodes = text.filter(function (d) {
        return leaves.indexOf(d) !== -1;
      }).nodes();
      var last = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(extremeNodes.map(function (node) {
        return node.getComputedTextLength();
      }))) + 6;
      var first = text.node().getComputedTextLength() + 6;
      if (last <= this.maxTextLenght.last && first <= this.maxTextLenght.first) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([allNodesPromise, exitingNodesPromise, textTransition, updateAndNewLinksPromise, exitingLinksPromise]);
      }

      this.maxTextLenght = { first: first, last: last };
      var size = this.getSize();
      if (this.zoomable) {
        this.internaldata.svg.call(this.internaldata.zoom.transform, this.currentTransform);
      } else {
        var g = this.internaldata.g;

        this.transformSvg(g, size);
      }
      this.layout.size(this.internaldata.tree, size, this.margin, this.maxTextLenght);
      return this.updateGraph(source);
    },
    onNodeClick: function onNodeClick(d) {
      if (d.children) {
        this.collapse(d);
      } else {
        this.expand(d);
      }
    },
    setColor: function setColor(d) {
      var name = d.data.name;
      d.color = this.color.domain().indexOf(name) >= 0 ? this.color(name) : d.parent ? d.parent.color : null;
      if (d.children) d.children.forEach(this.setColor);
    },
    onData: function onData(data) {
      var _this2 = this;

      if (!data) {
        this.internaldata.root = null;
        this.clean();
        return;
      }
      console.log('Tree Data:', data);
      var root = __WEBPACK_IMPORTED_MODULE_9_d3__["hierarchy"](data).sum(function (x) {
        return x.children ? 0 : 1;
      }).sort(function (a, b) {
        return a.length - b.length || __WEBPACK_IMPORTED_MODULE_9_d3__["ascending"](a.data.length, b.data.length);
        // return compareString(a.data.length, b.data.length)
      });
      this.internaldata.root = root;
      root.each(function (d) {
        d.id = _this2.identifier(d.data);
      });
      var size = this.getSize();
      root.x = size.height / 2;
      root.y = 0;
      root.x0 = root.x;
      root.y0 = root.y;
      this.setColor(root);
      this.redraw();
    },
    clean: function clean() {
      var _this3 = this;

      ['.linktree', '.nodetree', 'text', 'circle'].forEach(function (selector) {
        _this3.internaldata.g.selectAll(selector).transition().duration(_this3.duration).attr('opacity', 0).remove();
      });
    },
    redraw: function redraw() {
      var root = this.internaldata.root;
      if (root) {
        return this.updateGraph(root);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('no graph');
    },
    getNodeOriginComputer: function getNodeOriginComputer(originalVisibleNodes) {
      return function (node) {
        var parentVisible = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["findInParents"])(node, originalVisibleNodes);
        return { x: parentVisible.x0, y: parentVisible.y0 };
      };
    },
    applyZoom: function applyZoom(size) {
      var _internaldata = this.internaldata,
          g = _internaldata.g,
          zoom = _internaldata.zoom;

      if (this.zoomable) {
        g.call(zoom.transform, this.currentTransform);
      } else {
        this.transformSvg(g, size);
      }
    },
    applyTransition: function applyTransition(size, _ref2) {
      var margin = _ref2.margin,
          layout = _ref2.layout;
      var _internaldata2 = this.internaldata,
          g = _internaldata2.g,
          svg = _internaldata2.svg,
          zoom = _internaldata2.zoom;

      if (this.zoomable) {
        var transform = this.currentTransform;
        var oldMargin = margin || this.margin;
        var oldLayout = layout || this.layout;

        var nowTransform = oldLayout.updateTransform(transform, oldMargin, size, this.maxTextLenght);
        var nextRealTransform = this.updateTransform(transform, size);
        var current = __WEBPACK_IMPORTED_MODULE_9_d3__["zoomIdentity"].translate(transform.x + nowTransform.x - nextRealTransform.x, transform.y + nowTransform.y - nextRealTransform.y).scale(transform.k);

        svg.call(zoom.transform, current).transition().duration(this.duration).call(zoom.transform, transform);
      } else {
        var transitiong = g.transition().duration(this.duration);
        this.transformSvg(transitiong, size);
      }
    },
    mouseovered: function mouseovered(active) {
      return function (d) {
        __WEBPACK_IMPORTED_MODULE_9_d3__["select"](this).classed('label-active', active);
        __WEBPACK_IMPORTED_MODULE_9_d3__["select"](d.linkExtensionNode).classed('link-active', active);
        d = d.parent;
        while (d) {
          __WEBPACK_IMPORTED_MODULE_9_d3__["select"](d.linkExtensionNode).classed('link-active', active);
          d = d.parent;
        }
        // d3.select(d.linkExtensionNode).classed("link-extension--active", active).each(this.moveToFront)
      };
    },
    zoomed: function zoomed(g) {
      var _this4 = this;

      return function () {
        var transform = __WEBPACK_IMPORTED_MODULE_9_d3__["event"].transform;
        var size = _this4.getSize();
        var transformToApply = _this4.updateTransform(transform, size);
        _this4.currentTransform = transform;
        _this4.$emit('zoom', { transform: transform });
        g.attr('transform', transformToApply);
      };
    },
    updateIfNeeded: function updateIfNeeded(d, update) {
      return update ? this.updateGraph(d).then(function () {
        return true;
      }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(true);
    },


    // API
    collapse: function collapse(d) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!d.children) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }

      d._children = d.children;
      d.children = null;
      this.$emit('retract', { element: d, data: d.data });
      return this.updateIfNeeded(d, update);
    },
    expand: function expand(d) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!d._children) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }

      d.children = d._children;
      d._children = null;
      this.$emit('expand', { element: d, data: d.data });
      return this.updateIfNeeded(d, update);
    },
    expandAll: function expandAll(d) {
      var _this5 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var lastVisible = d.leaves();
      onAllChilddren(d, function (child) {
        _this5.expand(child, false);
      });
      return this.updateIfNeeded(this.getNodeOriginComputer(lastVisible), update);
    },
    collapseAll: function collapseAll(d) {
      var _this6 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      onAllChilddren(d, function (child) {
        return _this6.collapse(child, false);
      });
      return this.updateIfNeeded(d, update);
    },
    show: function show(d) {
      var _this7 = this;

      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var path = d.ancestors().reverse();
      var root = path.find(function (node) {
        return node.children === null;
      }) || d;
      path.forEach(function (node) {
        return _this7.expand(node, false);
      });
      return this.updateIfNeeded(root, update);
    },
    showOnly: function showOnly(d) {
      var _this8 = this;

      var root = this.internaldata.root;
      var path = d.ancestors().reverse();
      var shouldBeRetracted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["mapMany"])(path, function (p) {
        return p.children ? p.children : [];
      }).filter(function (node) {
        return node && path.indexOf(node) === -1;
      });
      var mapped = {};
      shouldBeRetracted.filter(function (node) {
        return node.children;
      }).forEach(function (rectractedNode) {
        return rectractedNode.each(function (c) {
          mapped[c.id] = rectractedNode;
        });
      });
      var origin = function origin(node) {
        var reference = mapped[node.id];
        return { x: reference.x, y: reference.y };
      };
      var updater = function updater(node) {
        if (shouldBeRetracted.indexOf(node) !== -1) {
          _this8.collapse(node, false);
          return false;
        }
        return node !== d;
      };
      onAllChilddren(root, updater);
      return this.updateGraph(origin).then(function () {
        return true;
      });
    },
    resetZoom: function resetZoom() {
      if (!this.zoomable) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(false);
      }
      var _internaldata3 = this.internaldata,
          svg = _internaldata3.svg,
          zoom = _internaldata3.zoom;

      var transitionPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__d3_utils__["toPromise"])(svg.transition().duration(this.duration).call(zoom.transform, function () {
        return __WEBPACK_IMPORTED_MODULE_9_d3__["zoomIdentity"];
      }));
      return transitionPromise.then(function () {
        return true;
      });
    }
  },

  computed: {
    tree: function tree() {
      var size = this.getSize();
      var tree = this.type === 'cluster' ? __WEBPACK_IMPORTED_MODULE_9_d3__["cluster"]() : __WEBPACK_IMPORTED_MODULE_9_d3__["tree"]();
      this.layout.size(tree, size, this.margin, this.maxTextLenght);
      return tree;
    },
    margin: function margin() {
      return { x: this.marginX, y: this.marginY };
    },
    layout: function layout() {
      return _layout[this.layoutType];
    }
  },

  watch: {
    data: function data(current, old) {
      this.onData(current);
    },
    type: function type() {
      if (!this.internaldata.tree) {
        return;
      }
      this.internaldata.tree = this.tree;
      this.redraw();
    },
    person: function person() {
      if (!this.internaldata.tree) {
        return;
      }
      this.redraw();
    },
    marginX: function marginX(newMarginX, oldMarginX) {
      this.completeRedraw({ margin: { x: oldMarginX, y: this.marginY } });
    },
    marginY: function marginY(newMarginY, oldMarginY) {
      this.completeRedraw({ margin: { x: this.marginX, y: oldMarginY } });
    },
    layout: function layout(newLayout, oldLayout) {
      this.completeRedraw({ layout: oldLayout });
    }
  }
});

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seen = exports.parseNewick = undefined;

var _family_stats = __webpack_require__(259);

var _family_stats2 = _interopRequireDefault(_family_stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import main from 'data/main'
// function assign (li, name) {
//  li.forEach(x => {
//    seen[x.Family][name] = x.estimate
//  })
// }
// assign(main, 'main')

var seen = _family_stats2.default.reduce(function (res, x) {
  res[x.fam] = x;
  return res;
}, {});

// <!-- A modified version of  https://github.com/jasondavies/newick.js -->
function parseNewick(s) {
  var ancestors = [];
  var tree = {};
  var tokens = s.split(/\s*(;|\(|\)|,|:)\s*/);
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    switch (token) {
      case '(':
        // new children
        var subtree = {};
        tree.children = [subtree];
        ancestors.push(tree);
        tree = subtree;
        break;
      case ',':
        // another branch
        subtree = {};
        ancestors[ancestors.length - 1].children.push(subtree);
        tree = subtree;
        break;
      case ')':
        // optional name next
        tree = ancestors.pop();
        break;
      case ':':
        // optional length next
        break;
      default:
        var x = tokens[i - 1];
        if (x === ')' || x === '(' || x === ',') {
          token = token.replace(/_/g, ' ');
          var name = token.replace(/ -.*/, '');
          if (name.match(/ ott[0-9]+$/)) {
            tree.ott = name.match(/ ott([0-9]+)$/)[2];
            name = name.replace(/ ott[0-9]+$/, '');
          }
          tree.name = name;
          if (seen[name]) {
            tree.lwr_95 = seen[name].lwr_95 ? seen[name].lwr_95 : 0;
            tree.estimate = seen[name].estimate ? seen[name].estimate : 0;
            tree.scaled_estimate = seen[name].scaled_estimate ? seen[name].scaled_estimate : 0;
            tree.upr_95 = seen[name].upr_95 ? seen[name].upr_95 : 0;
          }

          tree.common = token.replace(/.*?-/, '');
        } else if (x === ':') {
          tree.length = parseFloat(token);
        }
    }
  }
  return tree;
}
exports.parseNewick = parseNewick;
exports.seen = seen;

/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getRay(_ref, _ref2, _ref3) {
  var width = _ref.width,
      height = _ref.height;
  var x = _ref2.x,
      y = _ref2.y;
  var _ref3$xExtreme = _ref3.xExtreme,
      xExtreme = _ref3$xExtreme === undefined ? null : _ref3$xExtreme,
      _ref3$yExtreme = _ref3.yExtreme,
      yExtreme = _ref3$yExtreme === undefined ? null : _ref3$yExtreme;

  var firstRay = computeRay((width - x) / 2, xExtreme, Math.cos);
  var secondRay = computeRay((height - y) / 2, yExtreme, Math.sin);
  return Math.min(firstRay, secondRay);
}

function computeRay(space, extreme, trig) {
  if (!extreme) {
    return space;
  }
  var available = space - extreme.value;
  var angle = (extreme.x - 90) / 180 * Math.PI;
  return Math.abs(available / trig(angle));
}

exports.default = {
  size: function size(tree, _ref4, _ref5, _ref6) {
    var width = _ref4.width,
        height = _ref4.height;
    var x = _ref5.x,
        y = _ref5.y;
    var last = _ref6.last;

    var ray = Math.min(width - x, height - y) / 2 - last;
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1);
    });
  },
  optimizeSize: function optimizeSize(tree, size, margin, extreme) {
    var ray = getRay(size, margin, extreme || {});
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1);
    });
  },
  transformNode: function transformNode(x, y) {
    var angle = (x - 90) / 180 * Math.PI;
    var radius = y;
    return [~~(radius * Math.cos(angle)), ~~(radius * Math.sin(angle))];
  },
  transformSvg: function transformSvg(svg, margin, _ref7) {
    var width = _ref7.width,
        height = _ref7.height;

    return svg.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  },
  updateTransform: function updateTransform(transform, margin, _ref8) {
    var width = _ref8.width,
        height = _ref8.height;

    return transform.translate(width / 2, height / 2);
  },
  getLine: function getLine(d3) {
    return d3.radialLine().radius(function (d) {
      return d.y;
    }).angle(function (d) {
      return d.x / 180 * Math.PI;
    });
  },
  transformText: function transformText(d, children) {
    return {
      x: d.x < 180 === !children ? 6 : -6,
      rotate: d.x < 180 ? d.x - 90 : d.x + 90,
      anchor: d.x < 180 === !children ? 'start' : 'end'
    };
  }
};

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTexts = exports.translate = exports.toPromise = exports.roundPath = exports.removeTextAndGraph = exports.mapMany = exports.findInParents = exports.drawLink = exports.compareNode = exports.compareString = exports.anchorTodx = undefined;

var _promise = __webpack_require__(24);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function anchorTodx(d, el) {
  if (d === 'middle') {
    return -el.getBBox().width / 2;
  } else if (d === 'end') {
    return -el.getBBox().width;
  }
  return 0;
}

/*  return 'M' + transformNode(source.x, source.y) +
    ' ' + transformNode(source.x, (source.y + target.y) / 2) +
    ' ' + transformNode(target.x, (source.y + target.y) / 2) +
    ' ' + transformNode(target.x, target.y)
*/
function drawLink(source, target, _ref) {
  var transformNode = _ref.transformNode;

  // ssource = transformNode(source.x, source.y)
  // target = transformNode(target.x, target.y)
  return linkStep(target.x, target.y, source.x, source.y);
}

function linkStep(startAngle, startRadius, endAngle, endRadius) {
  var c0 = Math.cos(startAngle = (startAngle - 90) / 180 * Math.PI);
  var s0 = Math.sin(startAngle);
  var c1 = Math.cos(endAngle = (endAngle - 90) / 180 * Math.PI);
  var s1 = Math.sin(endAngle);
  // move to this point
  var out = 'M' + startRadius * c0 + ',' + startRadius * s0;
  if (endAngle !== startAngle) {
    out += 'A' + startRadius + ',' + startRadius + ' 0 0 ' + (endAngle > startAngle ? 1 : 0) + ' ' + startRadius * c1 + ',' + startRadius * s1;
  }
  return out + 'L' + endRadius * c1 + ',' + endRadius * s1;
}

function compareString(a, b) {
  return a < b ? -1 : a > b ? 1 : 0;
}

function compareNode(a, b, attribute) {
  if (a.height < b.height) {
    return 1;
  }
  if (a.height > b.height) {
    return -1;
  }
  return compareString(a.data[attribute], b.data[attribute]);
}

function findInParents(node, nodes) {
  if (nodes.indexOf(node) !== -1) {
    return node;
  }

  var parent = node.parent;
  return parent === null ? node : findInParents(parent, nodes);
}

function mapMany(arr, mapper) {
  return arr.reduce(function (prev, curr) {
    return prev.concat(mapper(curr));
  }, []);
}

function removeTextAndGraph(selection) {
  ['circle', 'text'].forEach(function (select) {
    selection.selectAll(select).remove();
  });
}

function roundPath(pathString) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return pathString.replace(/\d+\.\d+/g, function (s) {
    return parseFloat(s).toFixed(precision);
  });
}

function toPromise(transition) {
  var count = 0;
  var interrupted = false;
  transition.each(function () {
    return count++;
  });
  return new _promise2.default(function (resolve, reject) {
    if (count === 0) {
      resolve('ended');
      return;
    }
    var check = function check() {
      if (--count === 0) {
        resolve(interrupted ? 'interrupted' : 'ended');
      }
    };
    transition.on('end', check);
    transition.on('interrupt', function () {
      interrupted = true;
      check();
    });
  });
}

function translate(vector, _ref2) {
  var transformNode = _ref2.transformNode;

  return 'translate(' + transformNode(vector.x, vector.y) + ')';
}

function binarySearch(arr, left, right, value) {
  if (right < left) {
    return right;
  }

  var mid = Math.round(left + (right - left) / 2);
  if (arr(mid) === value) {
    return mid;
  }

  return arr(mid) > value ? binarySearch(arr, left, mid - 1, value) : binarySearch(arr, mid + 1, right, value);
}

function updateText(width) {
  var _this = this;

  var textString = this.textContent;
  var textLength = textString.length;
  if (this.getSubStringLength(0, textLength) <= width) {
    return;
  }

  var index = binarySearch(function (pos) {
    return _this.getSubStringLength(0, pos);
  }, 0, textLength - 3, width);
  this.textContent = textString.substring(0, index) + '...';
}

function updateTexts(selection, maxLength) {
  if (maxLength === -1) {
    return;
  }

  selection.each(function () {
    updateText.call(this, maxLength);
  });
}

exports.anchorTodx = anchorTodx;
exports.compareString = compareString;
exports.compareNode = compareNode;
exports.drawLink = drawLink;
exports.findInParents = findInParents;
exports.mapMany = mapMany;
exports.removeTextAndGraph = removeTextAndGraph;
exports.roundPath = roundPath;
exports.toPromise = toPromise;
exports.translate = translate;
exports.updateTexts = updateTexts;

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  size: function size(tree, _size, margin, _ref) {
    var last = _ref.last,
        first = _ref.first;

    tree.size([_size.height - margin.y * 2, _size.width - margin.x * 2 - (last + first)]);
  },
  transformNode: function transformNode(x, y) {
    return y + ',' + x;
  },
  transformSvg: function transformSvg(svg, margin, size, _ref2) {
    var first = _ref2.first;

    return svg.attr('transform', 'translate(' + margin.x + first + ',' + margin.y + ')');
  },
  updateTransform: function updateTransform(transform, _ref3, size, _ref4) {
    var x = _ref3.x,
        y = _ref3.y;
    var first = _ref4.first;

    return transform.translate(x + first, y);
  },
  getLine: function getLine(d3) {
    return d3.line().x(function (d) {
      return d.data.x;
    }).y(function (d) {
      return d.data.y;
    });
  },
  transformText: function transformText(text, children) {
    return {
      x: !children ? 6 : -6,
      rotate: 0,
      anchor: !children ? 'start' : 'end'
    };
  }
};

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tree = undefined;

var _Tree = __webpack_require__(247);

var _Tree2 = _interopRequireDefault(_Tree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.tree = _Tree2.default;

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function getRay(_ref, _ref2, _ref3) {
  var width = _ref.width,
      height = _ref.height;
  var x = _ref2.x,
      y = _ref2.y;
  var _ref3$xExtreme = _ref3.xExtreme,
      xExtreme = _ref3$xExtreme === undefined ? null : _ref3$xExtreme,
      _ref3$yExtreme = _ref3.yExtreme,
      yExtreme = _ref3$yExtreme === undefined ? null : _ref3$yExtreme;

  var firstRay = computeRay((width - x) / 2, xExtreme, Math.cos);
  var secondRay = computeRay((height - y) / 2, yExtreme, Math.sin);
  return Math.min(firstRay, secondRay);
}

function computeRay(space, extreme, trig) {
  if (!extreme) {
    return space;
  }
  var available = space - extreme.value;
  var angle = (extreme.x - 90) / 180 * Math.PI;
  return Math.abs(available / trig(angle));
}

exports.default = {
  size: function size(tree, _ref4, _ref5, _ref6) {
    var width = _ref4.width,
        height = _ref4.height;
    var x = _ref5.x,
        y = _ref5.y;
    var last = _ref6.last;

    // const ray = Math.min(width - x, height - y) / 2 - last
    tree.size([360, 360]).separation(function (a, b) {
      return 1;
      // return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth : 1)
    });
  },
  optimizeSize: function optimizeSize(tree, size, margin, extreme) {
    var ray = getRay(size, margin, extreme || {});
    tree.size([360, ray]).separation(function (a, b) {
      return (a.parent === b.parent ? 1 : 2) / (a.depth !== 0 ? a.depth + 1 : 1);
    });
  },
  transformNode: function transformNode(x, y) {
    var angle = (x - 90) / 180 * Math.PI;
    var radius = y;
    return [~~(radius * Math.cos(angle)), ~~(radius * Math.sin(angle))];
  },
  transformSvg: function transformSvg(svg, margin, _ref7) {
    var width = _ref7.width,
        height = _ref7.height;

    return svg.attr('transform', 'translate(' + width / 2 + ',' + height / 2 + ')');
  },
  updateTransform: function updateTransform(transform, margin, _ref8) {
    var width = _ref8.width,
        height = _ref8.height;

    return transform.translate(width / 2, height / 2);
  },
  getLine: function getLine(d3) {
    return d3.line();
  },
  transformText: function transformText(d, children) {
    return {
      x: d.x < 180 === !children ? 6 : -6,
      rotate: d.x < 180 ? d.x - 90 : d.x + 90,
      anchor: d.x < 180 === !children ? 'start' : 'end'
    };
  }
};

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(94);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(92);

var _App2 = _interopRequireDefault(_App);

var _vueAsyncComputed = __webpack_require__(91);

var _vueAsyncComputed2 = _interopRequireDefault(_vueAsyncComputed);

var _vueScrollto = __webpack_require__(93);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.config.productionTip = false;

window.introJS = __webpack_require__(90).introJs;

_vue2.default.use(_vueAsyncComputed2.default);

_vue2.default.use(_vueScrollto2.default);

/* eslint-disable no-new */
new _vue2.default({
  el: '#app',
  template: '<App/>',
  components: { App: _App2.default }
});

/***/ }),

/***/ 233:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 234:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 235:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 236:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 237:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(236)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(251),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-52186acf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(235)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(252),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58962b26",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(233)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(249),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(248),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 248:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.resize),
      expression: "resize"
    }],
    staticClass: "treeclass"
  })
},staticRenderFns: []}

/***/ }),

/***/ 249:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.selected) ? _c('div', {
    staticClass: "ui basic segment",
    class: {
      loading: _vm.loading
    }
  }, [_c('div', {
    staticClass: "ui stackable two column grid"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui rounded fluid image"
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl
    }
  }), (_vm.imageUrl) ? _c('div', {
    staticClass: "ui bottom attached label"
  }, [_vm._v(_vm._s(_vm.info ? (_vm.info.imageCaption ? _vm.info.imageCaption : _vm.selected) : 'No caption found.'))]) : _vm._e()])]), _c('div', {
    staticClass: "column",
    style: ([_vm.imageUrl ? '' : 'two wide'])
  }, [(_vm.text) ? _c('p', [_vm._v(_vm._s(_vm.text))]) : _vm._e(), (!_vm.text) ? _c('p', [_vm._v("No Wikipedia article found for "), _c('b', [_vm._v(_vm._s(_vm.selected) + " 😢")])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "ui rounded fluid image"
  }, [_c('img', {
    attrs: {
      "src": _vm.resultsImage
    }
  })])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 250:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tree', {
    staticClass: "tree",
    attrs: {
      "data": _vm.treeData,
      "layoutType": "radial",
      "type": "cluster",
      "duration": 50,
      "nodeText": "name",
      "margin-x": 0,
      "margin-y": 0,
      "person": _vm.selectedPerson,
      "data-step": "2",
      "data-intro": "This is a family-level phylogeny. You can click on the names at each tip of the tree to learn more about each family and our model results."
    },
    on: {
      "clicked": _vm.clicked,
      "hover": _vm.hover
    }
  }), (_vm.hoveredNode) ? _c('div', {
    ref: "floatingCard",
    staticClass: "ui card floating-card",
    style: (_vm.cardStyle)
  }, [(_vm.hoveredImage) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": _vm.hoveredImage
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.hoveredNode.name))]), _c('div', {
    staticClass: "meta"
  }, [_vm._v(_vm._s(_vm.hoveredTaxonomy))]), (_vm.hoveredSummary) ? _c('div', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.hoveredSummary))]) : _vm._e()])]) : _vm._e(), _c('div', {
    staticClass: "ui raised container segment"
  }, [_c('my-header', {
    attrs: {
      "main": _vm.selectedLeaf ? _vm.selectedLeaf : 'Select a Node to View Summary',
      "sub": _vm.common
    }
  }), (_vm.selectedTree === 'main') ? _c('div', {
    staticClass: "ui divider"
  }) : _vm._e(), (_vm.selectedTree === 'main') ? _c('table', {
    staticClass: "ui center aligned single line table"
  }, [_vm._m(0), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.people.lwr_95))]), _c('td', [_vm._v(_vm._s(_vm.people.estimate))]), _c('td', [_vm._v(_vm._s(_vm.people.upr_95))])])])]) : _vm._e(), (_vm.selectedLeaf) ? _c('div', {
    staticClass: "ui horizontal divider",
    attrs: {
      "id": "summary"
    }
  }, [_vm._v("Summary")]) : _vm._e(), _c('wiki-summary', {
    attrs: {
      "selected": _vm.selectedLeaf
    }
  })], 1), _c('attribution')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Lower Bound (95% CRI)")]), _c('th', [_vm._v("Mean Estimated Effect")]), _c('th', [_vm._v("Upper Bound (95% CRI)")])])])
}]}

/***/ }),

/***/ 251:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": _vm.link,
      "target": "blank"
    }
  }, [_c('h2', {
    staticClass: "ui center aligned header"
  }, [_vm._v(_vm._s(_vm.main)), _c('div', {
    staticClass: "sub header"
  }, [_vm._v(_vm._s(_vm.sub))])])])
},staticRenderFns: []}

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "floating-menu"
  }, [_c('div', {
    staticClass: "ui primary button",
    on: {
      "click": _vm.tutorial
    }
  }, [_vm._v("Tutorial")]), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#attribution'),
      expression: "'#attribution'"
    }],
    staticClass: "ui basic button",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")]), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-scale-container"
  }, [_c('div', {
    staticClass: "scale-label"
  }, [_vm._v("High (1.0)")]), _c('div', {
    staticClass: "scale-bar"
  }), _c('div', {
    staticClass: "scale-label"
  }, [_vm._v("Low (0.0)")])])
}]}

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui one column wide center aligned page padded grid",
    attrs: {
      "id": "attribution"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "ui horizontal divider"
  }, [_vm._v("Attribution")]), _c('p', [_vm._v("Text and Images: "), _c('a', {
    attrs: {
      "href": "https://en.wikipedia.org/wiki/Main_Page"
    }
  }, [_vm._v("Wikipedia,  ")]), _vm._v("Trees: "), _c('a', {
    attrs: {
      "href": "http://tree.opentreeoflife.org/"
    }
  }, [_vm._v("Open Tree of Life")])]), _c('p', [_vm._v("Inspired by: "), _c('a', {
    attrs: {
      "href": "https://bl.ocks.org/mbostock/c034d66572fd6bd6815a"
    }
  }, [_vm._v("Tree of Life")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "https://coreytcallaghan.github.io/eBirder-visualizations/"
    }
  }, [_vm._v("Family Birding Visualizer")])]), _c('p', [_vm._v("Developed by: Original code was developed by John Wilshire and adapted for this project by Vaughn Shirey and Corey Callaghan")])])])
}]}

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('my-menu'), _c('phylo-tree')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

module.exports = [{"Order":"Passeriformes","Family":"Acanthizidae","sp_count":37,"obs_count":37,"bio_count":2,"fam":"Acanthizidae","estimate":-0.32,"lwr_95":-1.42,"upr_95":0.92,"scaled_estimate":0.4207},{"Order":"Perciformes","Family":"Acanthuridae","sp_count":42,"obs_count":54,"bio_count":4,"fam":"Acanthuridae","estimate":0.18,"lwr_95":-0.62,"upr_95":0.9,"scaled_estimate":0.5449},{"Order":"Accipitriformes","Family":"Accipitridae","sp_count":120,"obs_count":425,"bio_count":35,"fam":"Accipitridae","estimate":-0.98,"lwr_95":-1.54,"upr_95":-0.42,"scaled_estimate":0.2729},{"Order":"Orthoptera","Family":"Acrididae","sp_count":106,"obs_count":206,"bio_count":16,"fam":"Acrididae","estimate":1.48,"lwr_95":-0.24,"upr_95":2.96,"scaled_estimate":0.8146},{"Order":"Passeriformes","Family":"Acrocephalidae","sp_count":16,"obs_count":52,"bio_count":10,"fam":"Acrocephalidae","estimate":-0.96,"lwr_95":-2.43,"upr_95":0.6,"scaled_estimate":0.2769},{"Order":"Actiniaria","Family":"Actiniidae","sp_count":22,"obs_count":30,"bio_count":6,"fam":"Actiniidae","estimate":-0.02,"lwr_95":-0.7,"upr_95":0.64,"scaled_estimate":0.495},{"Order":"Lepidoptera","Family":"Adelidae","sp_count":13,"obs_count":19,"bio_count":4,"fam":"Adelidae","estimate":0.04,"lwr_95":-1,"upr_95":1.1,"scaled_estimate":0.51},{"Order":"Dipsacales","Family":"Adoxaceae","sp_count":19,"obs_count":66,"bio_count":13,"fam":"Adoxaceae","estimate":1.08,"lwr_95":-0.29,"upr_95":2.37,"scaled_estimate":0.7465},{"Order":"Odonata","Family":"Aeshnidae","sp_count":38,"obs_count":85,"bio_count":13,"fam":"Aeshnidae","estimate":0.92,"lwr_95":0.07,"upr_95":1.75,"scaled_estimate":0.715},{"Order":"Squamata","Family":"Agamidae","sp_count":33,"obs_count":35,"bio_count":5,"fam":"Agamidae","estimate":0.63,"lwr_95":-1.07,"upr_95":2.21,"scaled_estimate":0.6525},{"Order":"Scleractinia","Family":"Agariciidae","sp_count":10,"obs_count":10,"bio_count":2,"fam":"Agariciidae","estimate":-0.06,"lwr_95":-0.92,"upr_95":0.87,"scaled_estimate":0.485},{"Order":"Passeriformes","Family":"Alaudidae","sp_count":28,"obs_count":72,"bio_count":14,"fam":"Alaudidae","estimate":0.59,"lwr_95":-0.23,"upr_95":1.37,"scaled_estimate":0.6434},{"Order":"Coraciiformes","Family":"Alcedinidae","sp_count":31,"obs_count":88,"bio_count":21,"fam":"Alcedinidae","estimate":0.38,"lwr_95":-0.71,"upr_95":1.46,"scaled_estimate":0.5939},{"Order":"Charadriiformes","Family":"Alcidae","sp_count":10,"obs_count":34,"bio_count":8,"fam":"Alcidae","estimate":-0.11,"lwr_95":-0.96,"upr_95":0.74,"scaled_estimate":0.4725},{"Order":"Caryophyllales","Family":"Amaranthaceae","sp_count":139,"obs_count":247,"bio_count":19,"fam":"Amaranthaceae","estimate":0.41,"lwr_95":-0.89,"upr_95":1.6,"scaled_estimate":0.6011},{"Order":"Asparagales","Family":"Amaryllidaceae","sp_count":42,"obs_count":107,"bio_count":12,"fam":"Amaryllidaceae","estimate":0.24,"lwr_95":-0.87,"upr_95":1.26,"scaled_estimate":0.5597},{"Order":"Sapindales","Family":"Anacardiaceae","sp_count":35,"obs_count":85,"bio_count":18,"fam":"Anacardiaceae","estimate":1.3,"lwr_95":-0.49,"upr_95":2.99,"scaled_estimate":0.7858},{"Order":"Anseriformes","Family":"Anatidae","sp_count":127,"obs_count":648,"bio_count":38,"fam":"Anatidae","estimate":0.52,"lwr_95":-0.17,"upr_95":1.22,"scaled_estimate":0.6271},{"Order":"Hymenoptera","Family":"Andrenidae","sp_count":62,"obs_count":115,"bio_count":6,"fam":"Andrenidae","estimate":0.5,"lwr_95":-0.39,"upr_95":1.26,"scaled_estimate":0.6225},{"Order":"Coleoptera","Family":"Anobiidae","sp_count":10,"obs_count":16,"bio_count":3,"fam":"Anobiidae","estimate":-0.14,"lwr_95":-1.5,"upr_95":1.33,"scaled_estimate":0.4651},{"Order":"Diptera","Family":"Anthomyiidae","sp_count":20,"obs_count":23,"bio_count":2,"fam":"Anthomyiidae","estimate":0.01,"lwr_95":-1.15,"upr_95":1.19,"scaled_estimate":0.5025},{"Order":"Hemiptera","Family":"Aphididae","sp_count":12,"obs_count":13,"bio_count":3,"fam":"Aphididae","estimate":-0.11,"lwr_95":-1.85,"upr_95":1.66,"scaled_estimate":0.4725},{"Order":"Coleoptera","Family":"Aphodiidae","sp_count":21,"obs_count":34,"bio_count":3,"fam":"Aphodiidae","estimate":0.01,"lwr_95":-0.59,"upr_95":0.58,"scaled_estimate":0.5025},{"Order":"Apiales","Family":"Apiaceae","sp_count":131,"obs_count":317,"bio_count":16,"fam":"Apiaceae","estimate":0.96,"lwr_95":0.22,"upr_95":1.63,"scaled_estimate":0.7231},{"Order":"Hymenoptera","Family":"Apidae","sp_count":151,"obs_count":315,"bio_count":25,"fam":"Apidae","estimate":0.4,"lwr_95":-0.58,"upr_95":1.21,"scaled_estimate":0.5987},{"Order":"Coleoptera","Family":"Apionidae","sp_count":18,"obs_count":30,"bio_count":3,"fam":"Apionidae","estimate":0.02,"lwr_95":-0.81,"upr_95":0.83,"scaled_estimate":0.505},{"Order":"Gentianales","Family":"Apocynaceae","sp_count":40,"obs_count":103,"bio_count":18,"fam":"Apocynaceae","estimate":1.1,"lwr_95":-0.71,"upr_95":2.86,"scaled_estimate":0.7503},{"Order":"Apodiformes","Family":"Apodidae","sp_count":17,"obs_count":33,"bio_count":12,"fam":"Apodidae","estimate":0.54,"lwr_95":-1.14,"upr_95":2.21,"scaled_estimate":0.6318},{"Order":"Aquifoliales","Family":"Aquifoliaceae","sp_count":11,"obs_count":19,"bio_count":4,"fam":"Aquifoliaceae","estimate":-0.27,"lwr_95":-2.08,"upr_95":1.59,"scaled_estimate":0.4329},{"Order":"Alismatales","Family":"Araceae","sp_count":23,"obs_count":64,"bio_count":13,"fam":"Araceae","estimate":0.98,"lwr_95":-0.56,"upr_95":2.46,"scaled_estimate":0.7271},{"Order":"Apiales","Family":"Araliaceae","sp_count":24,"obs_count":34,"bio_count":9,"fam":"Araliaceae","estimate":0.65,"lwr_95":-1.2,"upr_95":2.49,"scaled_estimate":0.657},{"Order":"Araneae","Family":"Araneidae","sp_count":66,"obs_count":144,"bio_count":19,"fam":"Araneidae","estimate":0.07,"lwr_95":-0.81,"upr_95":0.92,"scaled_estimate":0.5175},{"Order":"Lepidoptera","Family":"Arctiidae","sp_count":46,"obs_count":74,"bio_count":8,"fam":"Arctiidae","estimate":0.81,"lwr_95":-0.52,"upr_95":1.99,"scaled_estimate":0.6921},{"Order":"Pelecaniformes","Family":"Ardeidae","sp_count":48,"obs_count":319,"bio_count":39,"fam":"Ardeidae","estimate":-0.53,"lwr_95":-1.06,"upr_95":-0.02,"scaled_estimate":0.3705},{"Order":"Arecales","Family":"Arecaceae","sp_count":18,"obs_count":29,"bio_count":9,"fam":"Arecaceae","estimate":0.45,"lwr_95":-1.32,"upr_95":2.15,"scaled_estimate":0.6106},{"Order":"Lepidoptera","Family":"Argyresthiidae","sp_count":18,"obs_count":31,"bio_count":3,"fam":"Argyresthiidae","estimate":0.05,"lwr_95":-1.27,"upr_95":1.31,"scaled_estimate":0.5125},{"Order":"Diptera","Family":"Asilidae","sp_count":33,"obs_count":55,"bio_count":6,"fam":"Asilidae","estimate":-0.88,"lwr_95":-2.4,"upr_95":0.71,"scaled_estimate":0.2932},{"Order":"Asparagales","Family":"Asparagaceae","sp_count":80,"obs_count":188,"bio_count":17,"fam":"Asparagaceae","estimate":0.37,"lwr_95":-0.98,"upr_95":1.76,"scaled_estimate":0.5915},{"Order":"Asparagales","Family":"Asphodelaceae","sp_count":24,"obs_count":34,"bio_count":7,"fam":"Asphodelaceae","estimate":0.98,"lwr_95":-0.9,"upr_95":2.74,"scaled_estimate":0.7271},{"Order":"Polypodiales","Family":"Aspleniaceae","sp_count":14,"obs_count":42,"bio_count":8,"fam":"Aspleniaceae","estimate":0.1,"lwr_95":-0.79,"upr_95":0.99,"scaled_estimate":0.525},{"Order":"Asterales","Family":"Asteraceae","sp_count":639,"obs_count":1672,"bio_count":27,"fam":"Asteraceae","estimate":0.98,"lwr_95":0.31,"upr_95":1.65,"scaled_estimate":0.7271},{"Order":"Forcipulatida","Family":"Asteriidae","sp_count":12,"obs_count":17,"bio_count":6,"fam":"Asteriidae","estimate":0.1,"lwr_95":-0.78,"upr_95":0.91,"scaled_estimate":0.525},{"Order":"Ephemeroptera","Family":"Baetidae","sp_count":10,"obs_count":21,"bio_count":3,"fam":"Baetidae","estimate":0.32,"lwr_95":-0.75,"upr_95":1.33,"scaled_estimate":0.5793},{"Order":"Tetraodontiformes","Family":"Balistidae","sp_count":13,"obs_count":20,"bio_count":3,"fam":"Balistidae","estimate":-0.14,"lwr_95":-1.03,"upr_95":0.75,"scaled_estimate":0.4651},{"Order":"Ranunculales","Family":"Berberidaceae","sp_count":11,"obs_count":39,"bio_count":11,"fam":"Berberidaceae","estimate":1.28,"lwr_95":-0.4,"upr_95":2.78,"scaled_estimate":0.7824},{"Order":"Fagales","Family":"Betulaceae","sp_count":27,"obs_count":84,"bio_count":14,"fam":"Betulaceae","estimate":0.77,"lwr_95":-0.5,"upr_95":1.91,"scaled_estimate":0.6835},{"Order":"Lamiales","Family":"Bignoniaceae","sp_count":14,"obs_count":35,"bio_count":11,"fam":"Bignoniaceae","estimate":0.46,"lwr_95":-1.35,"upr_95":2.25,"scaled_estimate":0.613},{"Order":"Polypodiales","Family":"Blechnaceae","sp_count":10,"obs_count":12,"bio_count":3,"fam":"Blechnaceae","estimate":-0.15,"lwr_95":-1.44,"upr_95":1.15,"scaled_estimate":0.4626},{"Order":"Perciformes","Family":"Blenniidae","sp_count":21,"obs_count":27,"bio_count":5,"fam":"Blenniidae","estimate":-0.09,"lwr_95":-1.46,"upr_95":1.19,"scaled_estimate":0.4775},{"Order":"Diptera","Family":"Bombyliidae","sp_count":13,"obs_count":19,"bio_count":3,"fam":"Bombyliidae","estimate":0.59,"lwr_95":-0.89,"upr_95":1.88,"scaled_estimate":0.6434},{"Order":"Boraginales","Family":"Boraginaceae","sp_count":64,"obs_count":168,"bio_count":15,"fam":"Boraginaceae","estimate":0.89,"lwr_95":0.05,"upr_95":1.7,"scaled_estimate":0.7089},{"Order":"Artiodactyla","Family":"Bovidae","sp_count":43,"obs_count":78,"bio_count":12,"fam":"Bovidae","estimate":-0.13,"lwr_95":-0.31,"upr_95":0.06,"scaled_estimate":0.4675},{"Order":"Coleoptera","Family":"Brachyceridae","sp_count":10,"obs_count":18,"bio_count":3,"fam":"Brachyceridae","estimate":0.14,"lwr_95":-1.44,"upr_95":1.51,"scaled_estimate":0.5349},{"Order":"Brassicales","Family":"Brassicaceae","sp_count":170,"obs_count":463,"bio_count":19,"fam":"Brassicaceae","estimate":-0.19,"lwr_95":-1.72,"upr_95":1.28,"scaled_estimate":0.4526},{"Order":"Coleoptera","Family":"Brentidae","sp_count":10,"obs_count":15,"bio_count":2,"fam":"Brentidae","estimate":0.52,"lwr_95":-1.11,"upr_95":1.88,"scaled_estimate":0.6271},{"Order":"Neogastropoda","Family":"Buccinidae","sp_count":13,"obs_count":13,"bio_count":3,"fam":"Buccinidae","estimate":-0.05,"lwr_95":-1.67,"upr_95":1.63,"scaled_estimate":0.4875},{"Order":"Bucerotiformes","Family":"Bucerotidae","sp_count":22,"obs_count":37,"bio_count":8,"fam":"Bucerotidae","estimate":-0.78,"lwr_95":-2.08,"upr_95":0.65,"scaled_estimate":0.3143},{"Order":"Anura","Family":"Bufonidae","sp_count":27,"obs_count":51,"bio_count":16,"fam":"Bufonidae","estimate":1.39,"lwr_95":-0.18,"upr_95":2.8,"scaled_estimate":0.8006},{"Order":"Coleoptera","Family":"Buprestidae","sp_count":17,"obs_count":20,"bio_count":3,"fam":"Buprestidae","estimate":0.12,"lwr_95":-1.39,"upr_95":1.75,"scaled_estimate":0.53},{"Order":"Diptera","Family":"Calliphoridae","sp_count":13,"obs_count":26,"bio_count":3,"fam":"Calliphoridae","estimate":0.02,"lwr_95":-1.41,"upr_95":1.45,"scaled_estimate":0.505},{"Order":"Odonata","Family":"Calopterygidae","sp_count":10,"obs_count":24,"bio_count":9,"fam":"Calopterygidae","estimate":-0.6,"lwr_95":-1.85,"upr_95":0.94,"scaled_estimate":0.3543},{"Order":"Asterales","Family":"Campanulaceae","sp_count":59,"obs_count":125,"bio_count":12,"fam":"Campanulaceae","estimate":0.86,"lwr_95":-0.19,"upr_95":1.9,"scaled_estimate":0.7027},{"Order":"Passeriformes","Family":"Campephagidae","sp_count":18,"obs_count":19,"bio_count":4,"fam":"Campephagidae","estimate":0.4,"lwr_95":-1.14,"upr_95":1.91,"scaled_estimate":0.5987},{"Order":"Carnivora","Family":"Canidae","sp_count":12,"obs_count":41,"bio_count":14,"fam":"Canidae","estimate":0.09,"lwr_95":-0.88,"upr_95":1.1,"scaled_estimate":0.5225},{"Order":"Rosales","Family":"Cannabaceae","sp_count":10,"obs_count":24,"bio_count":9,"fam":"Cannabaceae","estimate":1.1,"lwr_95":-0.75,"upr_95":2.86,"scaled_estimate":0.7503},{"Order":"Coleoptera","Family":"Cantharidae","sp_count":32,"obs_count":69,"bio_count":5,"fam":"Cantharidae","estimate":0.85,"lwr_95":-0.46,"upr_95":1.85,"scaled_estimate":0.7006},{"Order":"Dipsacales","Family":"Caprifoliaceae","sp_count":60,"obs_count":146,"bio_count":13,"fam":"Caprifoliaceae","estimate":1.46,"lwr_95":0.37,"upr_95":2.42,"scaled_estimate":0.8115},{"Order":"Coleoptera","Family":"Carabidae","sp_count":272,"obs_count":442,"bio_count":13,"fam":"Carabidae","estimate":0.3,"lwr_95":-0.44,"upr_95":1.1,"scaled_estimate":0.5744},{"Order":"Perciformes","Family":"Carangidae","sp_count":15,"obs_count":18,"bio_count":3,"fam":"Carangidae","estimate":-0.03,"lwr_95":-0.42,"upr_95":0.33,"scaled_estimate":0.4925},{"Order":"Cardiida","Family":"Cardiidae","sp_count":10,"obs_count":15,"bio_count":3,"fam":"Cardiidae","estimate":0.27,"lwr_95":-1.05,"upr_95":1.48,"scaled_estimate":0.5671},{"Order":"Passeriformes","Family":"Cardinalidae","sp_count":27,"obs_count":76,"bio_count":10,"fam":"Cardinalidae","estimate":-0.08,"lwr_95":-1.68,"upr_95":1.46,"scaled_estimate":0.48},{"Order":"Caryophyllales","Family":"Caryophyllaceae","sp_count":130,"obs_count":363,"bio_count":18,"fam":"Caryophyllaceae","estimate":0.98,"lwr_95":0.2,"upr_95":1.71,"scaled_estimate":0.7271},{"Order":"Diptera","Family":"Cecidomyiidae","sp_count":11,"obs_count":14,"bio_count":4,"fam":"Cecidomyiidae","estimate":-0.15,"lwr_95":-1.6,"upr_95":1.45,"scaled_estimate":0.4626},{"Order":"Celastrales","Family":"Celastraceae","sp_count":21,"obs_count":45,"bio_count":13,"fam":"Celastraceae","estimate":1.33,"lwr_95":-0.29,"upr_95":2.81,"scaled_estimate":0.7908},{"Order":"Perciformes","Family":"Centrarchidae","sp_count":15,"obs_count":37,"bio_count":5,"fam":"Centrarchidae","estimate":0.21,"lwr_95":-1.03,"upr_95":1.39,"scaled_estimate":0.5523},{"Order":"Coleoptera","Family":"Cerambycidae","sp_count":141,"obs_count":235,"bio_count":12,"fam":"Cerambycidae","estimate":0.19,"lwr_95":-0.35,"upr_95":0.82,"scaled_estimate":0.5474},{"Order":"Primates","Family":"Cercopithecidae","sp_count":21,"obs_count":33,"bio_count":8,"fam":"Cercopithecidae","estimate":-0.31,"lwr_95":-1.33,"upr_95":0.73,"scaled_estimate":0.4231},{"Order":"Artiodactyla","Family":"Cervidae","sp_count":16,"obs_count":51,"bio_count":15,"fam":"Cervidae","estimate":-0.3,"lwr_95":-1.09,"upr_95":0.61,"scaled_estimate":0.4256},{"Order":"Coleoptera","Family":"Cetoniidae","sp_count":30,"obs_count":54,"bio_count":12,"fam":"Cetoniidae","estimate":0.68,"lwr_95":-0.92,"upr_95":2.23,"scaled_estimate":0.6637},{"Order":"Perciformes","Family":"Chaetodontidae","sp_count":39,"obs_count":46,"bio_count":5,"fam":"Chaetodontidae","estimate":0.27,"lwr_95":-0.65,"upr_95":1.22,"scaled_estimate":0.5671},{"Order":"Charadriiformes","Family":"Charadriidae","sp_count":46,"obs_count":173,"bio_count":30,"fam":"Charadriidae","estimate":0.71,"lwr_95":-0.01,"upr_95":1.41,"scaled_estimate":0.6704},{"Order":"Diptera","Family":"Chironomidae","sp_count":31,"obs_count":31,"bio_count":2,"fam":"Chironomidae","estimate":0.09,"lwr_95":-1.66,"upr_95":1.82,"scaled_estimate":0.5225},{"Order":"Nudibranchia","Family":"Chromodorididae","sp_count":11,"obs_count":11,"bio_count":2,"fam":"Chromodorididae","estimate":0.57,"lwr_95":-0.81,"upr_95":1.53,"scaled_estimate":0.6388},{"Order":"Coleoptera","Family":"Chrysomelidae","sp_count":167,"obs_count":265,"bio_count":11,"fam":"Chrysomelidae","estimate":-0.51,"lwr_95":-1.51,"upr_95":0.45,"scaled_estimate":0.3752},{"Order":"Hemiptera","Family":"Cicadellidae","sp_count":46,"obs_count":68,"bio_count":6,"fam":"Cicadellidae","estimate":0.52,"lwr_95":-0.9,"upr_95":1.87,"scaled_estimate":0.6271},{"Order":"Hemiptera","Family":"Cicadidae","sp_count":29,"obs_count":37,"bio_count":4,"fam":"Cicadidae","estimate":0.37,"lwr_95":-1.55,"upr_95":2.26,"scaled_estimate":0.5915},{"Order":"Ciconiiformes","Family":"Ciconiidae","sp_count":16,"obs_count":48,"bio_count":16,"fam":"Ciconiidae","estimate":-0.25,"lwr_95":-1.11,"upr_95":0.56,"scaled_estimate":0.4378},{"Order":"Malvales","Family":"Cistaceae","sp_count":34,"obs_count":44,"bio_count":3,"fam":"Cistaceae","estimate":0.31,"lwr_95":-1.45,"upr_95":1.95,"scaled_estimate":0.5769},{"Order":"Passeriformes","Family":"Cisticolidae","sp_count":30,"obs_count":46,"bio_count":10,"fam":"Cisticolidae","estimate":-0.37,"lwr_95":-1.96,"upr_95":1.24,"scaled_estimate":0.4085},{"Order":"Araneae","Family":"Clubionidae","sp_count":10,"obs_count":11,"bio_count":2,"fam":"Clubionidae","estimate":0.18,"lwr_95":-1.35,"upr_95":1.61,"scaled_estimate":0.5449},{"Order":"Coleoptera","Family":"Coccinellidae","sp_count":70,"obs_count":175,"bio_count":18,"fam":"Coccinellidae","estimate":0.67,"lwr_95":-0.38,"upr_95":1.65,"scaled_estimate":0.6615},{"Order":"Odonata","Family":"Coenagrionidae","sp_count":79,"obs_count":171,"bio_count":16,"fam":"Coenagrionidae","estimate":-0.41,"lwr_95":-1.22,"upr_95":0.35,"scaled_estimate":0.3989},{"Order":"Lepidoptera","Family":"Coleophoridae","sp_count":13,"obs_count":19,"bio_count":3,"fam":"Coleophoridae","estimate":0.38,"lwr_95":-0.89,"upr_95":1.51,"scaled_estimate":0.5939},{"Order":"Hymenoptera","Family":"Colletidae","sp_count":19,"obs_count":32,"bio_count":5,"fam":"Colletidae","estimate":-0.52,"lwr_95":-2.09,"upr_95":1.11,"scaled_estimate":0.3729},{"Order":"Squamata","Family":"Colubridae","sp_count":54,"obs_count":89,"bio_count":14,"fam":"Colubridae","estimate":0.17,"lwr_95":-0.61,"upr_95":0.82,"scaled_estimate":0.5424},{"Order":"Columbiformes","Family":"Columbidae","sp_count":82,"obs_count":217,"bio_count":36,"fam":"Columbidae","estimate":1.98,"lwr_95":0.55,"upr_95":3.37,"scaled_estimate":0.8787},{"Order":"Solanales","Family":"Convolvulaceae","sp_count":24,"obs_count":70,"bio_count":16,"fam":"Convolvulaceae","estimate":0.75,"lwr_95":-0.76,"upr_95":2.15,"scaled_estimate":0.6792},{"Order":"Odonata","Family":"Corduliidae","sp_count":22,"obs_count":39,"bio_count":8,"fam":"Corduliidae","estimate":0.26,"lwr_95":-0.32,"upr_95":0.81,"scaled_estimate":0.5646},{"Order":"Hemiptera","Family":"Coreidae","sp_count":22,"obs_count":43,"bio_count":9,"fam":"Coreidae","estimate":0.57,"lwr_95":-0.85,"upr_95":1.93,"scaled_estimate":0.6388},{"Order":"Cornales","Family":"Cornaceae","sp_count":14,"obs_count":38,"bio_count":12,"fam":"Cornaceae","estimate":0.85,"lwr_95":-0.66,"upr_95":2.26,"scaled_estimate":0.7006},{"Order":"Passeriformes","Family":"Corvidae","sp_count":61,"obs_count":189,"bio_count":37,"fam":"Corvidae","estimate":0.47,"lwr_95":-0.8,"upr_95":1.7,"scaled_estimate":0.6154},{"Order":"Passeriformes","Family":"Cotingidae","sp_count":16,"obs_count":16,"bio_count":3,"fam":"Cotingidae","estimate":-0.53,"lwr_95":-2.04,"upr_95":1.1,"scaled_estimate":0.3705},{"Order":"Hymenoptera","Family":"Crabronidae","sp_count":38,"obs_count":63,"bio_count":4,"fam":"Crabronidae","estimate":-0.35,"lwr_95":-2.06,"upr_95":1.38,"scaled_estimate":0.4134},{"Order":"Galliformes","Family":"Cracidae","sp_count":12,"obs_count":13,"bio_count":3,"fam":"Cracidae","estimate":-0.62,"lwr_95":-2.18,"upr_95":1.09,"scaled_estimate":0.3498},{"Order":"Lepidoptera","Family":"Crambidae","sp_count":197,"obs_count":361,"bio_count":13,"fam":"Crambidae","estimate":0.46,"lwr_95":0.02,"upr_95":0.97,"scaled_estimate":0.613},{"Order":"Saxifragales","Family":"Crassulaceae","sp_count":41,"obs_count":103,"bio_count":13,"fam":"Crassulaceae","estimate":1.39,"lwr_95":-0.04,"upr_95":2.66,"scaled_estimate":0.8006},{"Order":"Rodentia","Family":"Cricetidae","sp_count":51,"obs_count":94,"bio_count":15,"fam":"Cricetidae","estimate":1.41,"lwr_95":0.78,"upr_95":1.96,"scaled_estimate":0.8038},{"Order":"Cuculiformes","Family":"Cuculidae","sp_count":47,"obs_count":78,"bio_count":19,"fam":"Cuculidae","estimate":0.29,"lwr_95":-1.33,"upr_95":1.86,"scaled_estimate":0.572},{"Order":"Cucurbitales","Family":"Cucurbitaceae","sp_count":13,"obs_count":29,"bio_count":7,"fam":"Cucurbitaceae","estimate":0.35,"lwr_95":-1.11,"upr_95":1.8,"scaled_estimate":0.5866},{"Order":"Diptera","Family":"Culicidae","sp_count":12,"obs_count":19,"bio_count":5,"fam":"Culicidae","estimate":-0.53,"lwr_95":-2.35,"upr_95":1.34,"scaled_estimate":0.3705},{"Order":"Pinales","Family":"Cupressaceae","sp_count":33,"obs_count":74,"bio_count":14,"fam":"Cupressaceae","estimate":1.53,"lwr_95":-0.03,"upr_95":2.96,"scaled_estimate":0.822},{"Order":"Coleoptera","Family":"Curculionidae","sp_count":179,"obs_count":285,"bio_count":10,"fam":"Curculionidae","estimate":0.77,"lwr_95":-0.77,"upr_95":2.21,"scaled_estimate":0.6835},{"Order":"Hymenoptera","Family":"Cynipidae","sp_count":20,"obs_count":30,"bio_count":4,"fam":"Cynipidae","estimate":0.12,"lwr_95":-1.24,"upr_95":1.53,"scaled_estimate":0.53},{"Order":"Poales","Family":"Cyperaceae","sp_count":214,"obs_count":423,"bio_count":12,"fam":"Cyperaceae","estimate":0.5,"lwr_95":0.07,"upr_95":0.97,"scaled_estimate":0.6225},{"Order":"Cypriniformes","Family":"Cyprinidae","sp_count":52,"obs_count":93,"bio_count":11,"fam":"Cyprinidae","estimate":1.59,"lwr_95":0.57,"upr_95":2.5,"scaled_estimate":0.8306},{"Order":"Squamata","Family":"Dactyloidae","sp_count":14,"obs_count":19,"bio_count":4,"fam":"Dactyloidae","estimate":0.08,"lwr_95":-1.8,"upr_95":1.94,"scaled_estimate":0.52},{"Order":"Dasyuromorphia","Family":"Dasyuridae","sp_count":23,"obs_count":23,"bio_count":1,"fam":"Dasyuridae","estimate":0.09,"lwr_95":-0.02,"upr_95":0.21,"scaled_estimate":0.5225},{"Order":"Cetacea","Family":"Delphinidae","sp_count":14,"obs_count":40,"bio_count":10,"fam":"Delphinidae","estimate":-0.14,"lwr_95":-0.7,"upr_95":0.49,"scaled_estimate":0.4651},{"Order":"Passeriformes","Family":"Dicruridae","sp_count":10,"obs_count":16,"bio_count":4,"fam":"Dicruridae","estimate":0.2,"lwr_95":-1.6,"upr_95":1.95,"scaled_estimate":0.5498},{"Order":"Araneae","Family":"Dictynidae","sp_count":10,"obs_count":11,"bio_count":2,"fam":"Dictynidae","estimate":0.35,"lwr_95":-1.31,"upr_95":1.91,"scaled_estimate":0.5866},{"Order":"Squamata","Family":"Diplodactylidae","sp_count":20,"obs_count":20,"bio_count":1,"fam":"Diplodactylidae","estimate":0.07,"lwr_95":-0.04,"upr_95":0.18,"scaled_estimate":0.5175},{"Order":"Squamata","Family":"Dipsadidae","sp_count":10,"obs_count":16,"bio_count":5,"fam":"Dipsadidae","estimate":-1.12,"lwr_95":-2.03,"upr_95":0.03,"scaled_estimate":0.246},{"Order":"Diptera","Family":"Dolichopodidae","sp_count":20,"obs_count":37,"bio_count":3,"fam":"Dolichopodidae","estimate":-0.08,"lwr_95":-0.85,"upr_95":0.73,"scaled_estimate":0.48},{"Order":"Lepidoptera","Family":"Drepanidae","sp_count":22,"obs_count":43,"bio_count":5,"fam":"Drepanidae","estimate":-0.05,"lwr_95":-0.56,"upr_95":0.44,"scaled_estimate":0.4875},{"Order":"Polypodiales","Family":"Dryopteridaceae","sp_count":16,"obs_count":46,"bio_count":8,"fam":"Dryopteridaceae","estimate":0.54,"lwr_95":0.02,"upr_95":1.06,"scaled_estimate":0.6318},{"Order":"Coleoptera","Family":"Dytiscidae","sp_count":57,"obs_count":91,"bio_count":3,"fam":"Dytiscidae","estimate":0.05,"lwr_95":-0.47,"upr_95":0.57,"scaled_estimate":0.5125},{"Order":"Lepidoptera","Family":"Elachistidae","sp_count":40,"obs_count":65,"bio_count":4,"fam":"Elachistidae","estimate":0.11,"lwr_95":-0.81,"upr_95":0.9,"scaled_estimate":0.5275},{"Order":"Squamata","Family":"Elapidae","sp_count":30,"obs_count":30,"bio_count":2,"fam":"Elapidae","estimate":0.1,"lwr_95":-1.55,"upr_95":1.52,"scaled_estimate":0.525},{"Order":"Coleoptera","Family":"Elateridae","sp_count":39,"obs_count":63,"bio_count":3,"fam":"Elateridae","estimate":-0.06,"lwr_95":-0.63,"upr_95":0.55,"scaled_estimate":0.485},{"Order":"Passeriformes","Family":"Emberizidae","sp_count":73,"obs_count":234,"bio_count":26,"fam":"Emberizidae","estimate":-0.69,"lwr_95":-1.41,"upr_95":0.01,"scaled_estimate":0.334},{"Order":"Diptera","Family":"Empididae","sp_count":14,"obs_count":20,"bio_count":3,"fam":"Empididae","estimate":0.28,"lwr_95":-1.09,"upr_95":1.54,"scaled_estimate":0.5695},{"Order":"Testudines","Family":"Emydidae","sp_count":11,"obs_count":29,"bio_count":8,"fam":"Emydidae","estimate":1.04,"lwr_95":-0.7,"upr_95":2.68,"scaled_estimate":0.7389},{"Order":"Collembola","Family":"Entomobryidae","sp_count":12,"obs_count":19,"bio_count":3,"fam":"Entomobryidae","estimate":0.89,"lwr_95":-0.77,"upr_95":2.32,"scaled_estimate":0.7089},{"Order":"Lepidoptera","Family":"Erebidae","sp_count":160,"obs_count":316,"bio_count":13,"fam":"Erebidae","estimate":0.33,"lwr_95":-0.43,"upr_95":0.91,"scaled_estimate":0.5818},{"Order":"Ericales","Family":"Ericaceae","sp_count":130,"obs_count":272,"bio_count":17,"fam":"Ericaceae","estimate":0.68,"lwr_95":-0.15,"upr_95":1.43,"scaled_estimate":0.6637},{"Order":"Passeriformes","Family":"Estrildidae","sp_count":41,"obs_count":62,"bio_count":10,"fam":"Estrildidae","estimate":0.07,"lwr_95":-0.86,"upr_95":0.99,"scaled_estimate":0.5175},{"Order":"Hymenoptera","Family":"Eumenidae","sp_count":30,"obs_count":55,"bio_count":11,"fam":"Eumenidae","estimate":-0.78,"lwr_95":-2.56,"upr_95":1.07,"scaled_estimate":0.3143},{"Order":"Malpighiales","Family":"Euphorbiaceae","sp_count":70,"obs_count":187,"bio_count":22,"fam":"Euphorbiaceae","estimate":-0.11,"lwr_95":-1.47,"upr_95":1.26,"scaled_estimate":0.4725},{"Order":"Fabales","Family":"Fabaceae","sp_count":448,"obs_count":993,"bio_count":30,"fam":"Fabaceae","estimate":1.92,"lwr_95":1.03,"upr_95":2.74,"scaled_estimate":0.8721},{"Order":"Fagales","Family":"Fagaceae","sp_count":65,"obs_count":124,"bio_count":11,"fam":"Fagaceae","estimate":0.13,"lwr_95":-1.18,"upr_95":1.41,"scaled_estimate":0.5325},{"Order":"Falconiformes","Family":"Falconidae","sp_count":34,"obs_count":119,"bio_count":28,"fam":"Falconidae","estimate":0.32,"lwr_95":-0.65,"upr_95":1.32,"scaled_estimate":0.5793},{"Order":"Hymenoptera","Family":"Formicidae","sp_count":86,"obs_count":135,"bio_count":18,"fam":"Formicidae","estimate":-0.43,"lwr_95":-1.78,"upr_95":0.96,"scaled_estimate":0.3941},{"Order":"Passeriformes","Family":"Fringillidae","sp_count":70,"obs_count":221,"bio_count":29,"fam":"Fringillidae","estimate":-0.49,"lwr_95":-1.23,"upr_95":0.3,"scaled_estimate":0.3799},{"Order":"Passeriformes","Family":"Furnariidae","sp_count":25,"obs_count":26,"bio_count":4,"fam":"Furnariidae","estimate":0.14,"lwr_95":-1.61,"upr_95":1.89,"scaled_estimate":0.5349},{"Order":"Squamata","Family":"Gekkonidae","sp_count":24,"obs_count":37,"bio_count":10,"fam":"Gekkonidae","estimate":-0.59,"lwr_95":-2.29,"upr_95":1.21,"scaled_estimate":0.3566},{"Order":"Lepidoptera","Family":"Gelechiidae","sp_count":73,"obs_count":112,"bio_count":6,"fam":"Gelechiidae","estimate":-0.36,"lwr_95":-1.2,"upr_95":0.45,"scaled_estimate":0.411},{"Order":"Gentianales","Family":"Gentianaceae","sp_count":39,"obs_count":76,"bio_count":11,"fam":"Gentianaceae","estimate":0.21,"lwr_95":-0.98,"upr_95":1.41,"scaled_estimate":0.5523},{"Order":"Lepidoptera","Family":"Geometridae","sp_count":469,"obs_count":926,"bio_count":13,"fam":"Geometridae","estimate":-0.49,"lwr_95":-1,"upr_95":-0.02,"scaled_estimate":0.3799},{"Order":"Geraniales","Family":"Geraniaceae","sp_count":37,"obs_count":130,"bio_count":17,"fam":"Geraniaceae","estimate":-0.49,"lwr_95":-1.59,"upr_95":0.56,"scaled_estimate":0.3799},{"Order":"Perciformes","Family":"Gobiidae","sp_count":31,"obs_count":42,"bio_count":6,"fam":"Gobiidae","estimate":0.52,"lwr_95":-0.42,"upr_95":1.29,"scaled_estimate":0.6271},{"Order":"Odonata","Family":"Gomphidae","sp_count":31,"obs_count":50,"bio_count":8,"fam":"Gomphidae","estimate":-0.09,"lwr_95":-1.32,"upr_95":1.17,"scaled_estimate":0.4775},{"Order":"Asterales","Family":"Goodeniaceae","sp_count":15,"obs_count":15,"bio_count":1,"fam":"Goodeniaceae","estimate":0.3,"lwr_95":-0.02,"upr_95":0.61,"scaled_estimate":0.5744},{"Order":"Lepidoptera","Family":"Gracillariidae","sp_count":50,"obs_count":74,"bio_count":4,"fam":"Gracillariidae","estimate":-0.17,"lwr_95":-1.29,"upr_95":1.07,"scaled_estimate":0.4576},{"Order":"Saxifragales","Family":"Grossulariaceae","sp_count":18,"obs_count":42,"bio_count":9,"fam":"Grossulariaceae","estimate":0.96,"lwr_95":-0.31,"upr_95":2.15,"scaled_estimate":0.7231},{"Order":"Orthoptera","Family":"Gryllidae","sp_count":10,"obs_count":15,"bio_count":4,"fam":"Gryllidae","estimate":0.09,"lwr_95":-1.67,"upr_95":1.83,"scaled_estimate":0.5225},{"Order":"Hymenoptera","Family":"Halictidae","sp_count":99,"obs_count":179,"bio_count":9,"fam":"Halictidae","estimate":0.65,"lwr_95":-0.97,"upr_95":2.16,"scaled_estimate":0.657},{"Order":"Coleoptera","Family":"Haliplidae","sp_count":10,"obs_count":15,"bio_count":2,"fam":"Haliplidae","estimate":0.38,"lwr_95":-1.09,"upr_95":1.59,"scaled_estimate":0.5939},{"Order":"Saxifragales","Family":"Haloragaceae","sp_count":12,"obs_count":19,"bio_count":5,"fam":"Haloragaceae","estimate":-0.01,"lwr_95":-1.19,"upr_95":1.14,"scaled_estimate":0.4975},{"Order":"Lepidoptera","Family":"Hesperiidae","sp_count":115,"obs_count":224,"bio_count":17,"fam":"Hesperiidae","estimate":0.06,"lwr_95":-0.68,"upr_95":0.8,"scaled_estimate":0.515},{"Order":"Rodentia","Family":"Heteromyidae","sp_count":14,"obs_count":19,"bio_count":3,"fam":"Heteromyidae","estimate":-0.02,"lwr_95":-0.44,"upr_95":0.44,"scaled_estimate":0.495},{"Order":"Passeriformes","Family":"Hirundinidae","sp_count":45,"obs_count":142,"bio_count":30,"fam":"Hirundinidae","estimate":0.03,"lwr_95":-1.01,"upr_95":1.05,"scaled_estimate":0.5075},{"Order":"Beryciformes","Family":"Holocentridae","sp_count":13,"obs_count":13,"bio_count":2,"fam":"Holocentridae","estimate":0.01,"lwr_95":-0.97,"upr_95":1.09,"scaled_estimate":0.5025},{"Order":"Diptera","Family":"Hybotidae","sp_count":14,"obs_count":17,"bio_count":2,"fam":"Hybotidae","estimate":0.2,"lwr_95":-1.28,"upr_95":1.47,"scaled_estimate":0.5498},{"Order":"Coleoptera","Family":"Hydrophilidae","sp_count":32,"obs_count":49,"bio_count":3,"fam":"Hydrophilidae","estimate":0.11,"lwr_95":-0.76,"upr_95":0.95,"scaled_estimate":0.5275},{"Order":"Anura","Family":"Hylidae","sp_count":78,"obs_count":100,"bio_count":11,"fam":"Hylidae","estimate":0.9,"lwr_95":-0.51,"upr_95":2.02,"scaled_estimate":0.7109},{"Order":"Malpighiales","Family":"Hypericaceae","sp_count":26,"obs_count":61,"bio_count":12,"fam":"Hypericaceae","estimate":0.04,"lwr_95":-1.37,"upr_95":1.43,"scaled_estimate":0.51},{"Order":"Passeriformes","Family":"Icteridae","sp_count":56,"obs_count":135,"bio_count":13,"fam":"Icteridae","estimate":0.33,"lwr_95":-1.31,"upr_95":1.93,"scaled_estimate":0.5818},{"Order":"Asparagales","Family":"Iridaceae","sp_count":33,"obs_count":60,"bio_count":11,"fam":"Iridaceae","estimate":0.3,"lwr_95":-1,"upr_95":1.66,"scaled_estimate":0.5744},{"Order":"Julida","Family":"Julidae","sp_count":11,"obs_count":14,"bio_count":3,"fam":"Julidae","estimate":0.11,"lwr_95":-1.71,"upr_95":1.93,"scaled_estimate":0.5275},{"Order":"Poales","Family":"Juncaceae","sp_count":55,"obs_count":131,"bio_count":8,"fam":"Juncaceae","estimate":0.48,"lwr_95":0.08,"upr_95":0.89,"scaled_estimate":0.6177},{"Order":"Perciformes","Family":"Kyphosidae","sp_count":12,"obs_count":12,"bio_count":3,"fam":"Kyphosidae","estimate":0.05,"lwr_95":-1.33,"upr_95":1.53,"scaled_estimate":0.5125},{"Order":"Perciformes","Family":"Labridae","sp_count":109,"obs_count":132,"bio_count":12,"fam":"Labridae","estimate":-0.18,"lwr_95":-0.51,"upr_95":0.11,"scaled_estimate":0.4551},{"Order":"Squamata","Family":"Lacertidae","sp_count":37,"obs_count":53,"bio_count":6,"fam":"Lacertidae","estimate":-0.38,"lwr_95":-1.93,"upr_95":1.25,"scaled_estimate":0.4061},{"Order":"Lamiales","Family":"Lamiaceae","sp_count":159,"obs_count":454,"bio_count":19,"fam":"Lamiaceae","estimate":0.24,"lwr_95":-0.94,"upr_95":1.26,"scaled_estimate":0.5597},{"Order":"Passeriformes","Family":"Laniidae","sp_count":23,"obs_count":82,"bio_count":21,"fam":"Laniidae","estimate":-0.56,"lwr_95":-1.77,"upr_95":0.77,"scaled_estimate":0.3635},{"Order":"Charadriiformes","Family":"Laridae","sp_count":74,"obs_count":327,"bio_count":37,"fam":"Laridae","estimate":1,"lwr_95":-0.04,"upr_95":2,"scaled_estimate":0.7311},{"Order":"Lepidoptera","Family":"Lasiocampidae","sp_count":19,"obs_count":46,"bio_count":9,"fam":"Lasiocampidae","estimate":-0.85,"lwr_95":-2.24,"upr_95":0.44,"scaled_estimate":0.2994},{"Order":"Coleoptera","Family":"Latridiidae","sp_count":12,"obs_count":18,"bio_count":4,"fam":"Latridiidae","estimate":-0.32,"lwr_95":-1.21,"upr_95":0.6,"scaled_estimate":0.4207},{"Order":"Laurales","Family":"Lauraceae","sp_count":13,"obs_count":18,"bio_count":5,"fam":"Lauraceae","estimate":0.57,"lwr_95":-1.15,"upr_95":2.19,"scaled_estimate":0.6388},{"Order":"Diptera","Family":"Lauxaniidae","sp_count":12,"obs_count":15,"bio_count":2,"fam":"Lauxaniidae","estimate":0.22,"lwr_95":-1.42,"upr_95":1.67,"scaled_estimate":0.5548},{"Order":"Coleoptera","Family":"Leiodidae","sp_count":10,"obs_count":10,"bio_count":2,"fam":"Leiodidae","estimate":-0.01,"lwr_95":-1.43,"upr_95":1.49,"scaled_estimate":0.4975},{"Order":"Passeriformes","Family":"Leiothrichidae","sp_count":21,"obs_count":21,"bio_count":5,"fam":"Leiothrichidae","estimate":0.57,"lwr_95":-1.31,"upr_95":2.42,"scaled_estimate":0.6388},{"Order":"Lamiales","Family":"Lentibulariaceae","sp_count":11,"obs_count":21,"bio_count":5,"fam":"Lentibulariaceae","estimate":0.21,"lwr_95":-0.49,"upr_95":0.75,"scaled_estimate":0.5523},{"Order":"Lagomorpha","Family":"Leporidae","sp_count":15,"obs_count":43,"bio_count":13,"fam":"Leporidae","estimate":-0.28,"lwr_95":-1.96,"upr_95":1.4,"scaled_estimate":0.4305},{"Order":"Trichoptera","Family":"Leptoceridae","sp_count":24,"obs_count":35,"bio_count":3,"fam":"Leptoceridae","estimate":0.01,"lwr_95":-1.06,"upr_95":1.08,"scaled_estimate":0.5025},{"Order":"Odonata","Family":"Lestidae","sp_count":20,"obs_count":41,"bio_count":9,"fam":"Lestidae","estimate":1,"lwr_95":-0.49,"upr_95":2.33,"scaled_estimate":0.7311},{"Order":"Odonata","Family":"Libellulidae","sp_count":161,"obs_count":395,"bio_count":27,"fam":"Libellulidae","estimate":0.66,"lwr_95":0.23,"upr_95":1.05,"scaled_estimate":0.6593},{"Order":"Liliales","Family":"Liliaceae","sp_count":25,"obs_count":56,"bio_count":10,"fam":"Liliaceae","estimate":-0.1,"lwr_95":-1.35,"upr_95":1.17,"scaled_estimate":0.475},{"Order":"Lepidoptera","Family":"Limacodidae","sp_count":10,"obs_count":14,"bio_count":2,"fam":"Limacodidae","estimate":0.51,"lwr_95":-0.91,"upr_95":1.63,"scaled_estimate":0.6248},{"Order":"Trichoptera","Family":"Limnephilidae","sp_count":27,"obs_count":46,"bio_count":3,"fam":"Limnephilidae","estimate":0.41,"lwr_95":-0.67,"upr_95":1.38,"scaled_estimate":0.6011},{"Order":"Anura","Family":"Limnodynastidae","sp_count":18,"obs_count":18,"bio_count":1,"fam":"Limnodynastidae","estimate":0.56,"lwr_95":-0.59,"upr_95":1.66,"scaled_estimate":0.6365},{"Order":"Diptera","Family":"Limoniidae","sp_count":54,"obs_count":61,"bio_count":3,"fam":"Limoniidae","estimate":-0.34,"lwr_95":-1.3,"upr_95":0.65,"scaled_estimate":0.4158},{"Order":"Malpighiales","Family":"Linaceae","sp_count":15,"obs_count":27,"bio_count":6,"fam":"Linaceae","estimate":0.91,"lwr_95":-0.93,"upr_95":2.61,"scaled_estimate":0.713},{"Order":"Araneae","Family":"Linyphiidae","sp_count":109,"obs_count":156,"bio_count":7,"fam":"Linyphiidae","estimate":0.23,"lwr_95":-0.33,"upr_95":0.7,"scaled_estimate":0.5572},{"Order":"Crassiclitellata","Family":"Lumbricidae","sp_count":16,"obs_count":26,"bio_count":3,"fam":"Lumbricidae","estimate":0.85,"lwr_95":-0.22,"upr_95":1.65,"scaled_estimate":0.7006},{"Order":"Perciformes","Family":"Lutjanidae","sp_count":12,"obs_count":12,"bio_count":2,"fam":"Lutjanidae","estimate":-0.43,"lwr_95":-1.89,"upr_95":1.28,"scaled_estimate":0.3941},{"Order":"Lepidoptera","Family":"Lycaenidae","sp_count":159,"obs_count":348,"bio_count":22,"fam":"Lycaenidae","estimate":0.1,"lwr_95":-0.81,"upr_95":1.07,"scaled_estimate":0.525},{"Order":"Lycopodiales","Family":"Lycopodiaceae","sp_count":11,"obs_count":27,"bio_count":6,"fam":"Lycopodiaceae","estimate":0.04,"lwr_95":-0.19,"upr_95":0.24,"scaled_estimate":0.51},{"Order":"Araneae","Family":"Lycosidae","sp_count":36,"obs_count":52,"bio_count":5,"fam":"Lycosidae","estimate":0.36,"lwr_95":-0.64,"upr_95":1.49,"scaled_estimate":0.589},{"Order":"Hemiptera","Family":"Lygaeidae","sp_count":13,"obs_count":28,"bio_count":9,"fam":"Lygaeidae","estimate":0.31,"lwr_95":-1.49,"upr_95":2.11,"scaled_estimate":0.5769},{"Order":"Myrtales","Family":"Lythraceae","sp_count":10,"obs_count":35,"bio_count":12,"fam":"Lythraceae","estimate":1.58,"lwr_95":-0.4,"upr_95":3.48,"scaled_estimate":0.8292},{"Order":"Diprotodontia","Family":"Macropodidae","sp_count":17,"obs_count":17,"bio_count":1,"fam":"Macropodidae","estimate":0.44,"lwr_95":0.07,"upr_95":0.8,"scaled_estimate":0.6083},{"Order":"Gadiformes","Family":"Macrouridae","sp_count":14,"obs_count":18,"bio_count":2,"fam":"Macrouridae","estimate":0.03,"lwr_95":-0.04,"upr_95":0.25,"scaled_estimate":0.5075},{"Order":"Passeriformes","Family":"Malaconotidae","sp_count":15,"obs_count":21,"bio_count":4,"fam":"Malaconotidae","estimate":0.11,"lwr_95":-0.5,"upr_95":0.67,"scaled_estimate":0.5275},{"Order":"Passeriformes","Family":"Maluridae","sp_count":13,"obs_count":13,"bio_count":1,"fam":"Maluridae","estimate":-0.19,"lwr_95":-0.75,"upr_95":0.38,"scaled_estimate":0.4526},{"Order":"Malvales","Family":"Malvaceae","sp_count":69,"obs_count":174,"bio_count":20,"fam":"Malvaceae","estimate":0.61,"lwr_95":-0.54,"upr_95":1.7,"scaled_estimate":0.6479},{"Order":"Mantodea","Family":"Mantidae","sp_count":16,"obs_count":24,"bio_count":7,"fam":"Mantidae","estimate":0.08,"lwr_95":-1.57,"upr_95":1.72,"scaled_estimate":0.52},{"Order":"Hymenoptera","Family":"Megachilidae","sp_count":45,"obs_count":82,"bio_count":7,"fam":"Megachilidae","estimate":1.16,"lwr_95":-0.76,"upr_95":2.75,"scaled_estimate":0.7613},{"Order":"Liliales","Family":"Melanthiaceae","sp_count":10,"obs_count":17,"bio_count":6,"fam":"Melanthiaceae","estimate":-0.53,"lwr_95":-1.85,"upr_95":0.85,"scaled_estimate":0.3705},{"Order":"Passeriformes","Family":"Meliphagidae","sp_count":70,"obs_count":72,"bio_count":3,"fam":"Meliphagidae","estimate":0.39,"lwr_95":-0.82,"upr_95":1.46,"scaled_estimate":0.5963},{"Order":"Coraciiformes","Family":"Meropidae","sp_count":17,"obs_count":45,"bio_count":11,"fam":"Meropidae","estimate":-0.85,"lwr_95":-2.12,"upr_95":0.48,"scaled_estimate":0.2994},{"Order":"Passeriformes","Family":"Mimidae","sp_count":18,"obs_count":42,"bio_count":11,"fam":"Mimidae","estimate":-0.53,"lwr_95":-2.13,"upr_95":1.1,"scaled_estimate":0.3705},{"Order":"Hemiptera","Family":"Miridae","sp_count":90,"obs_count":152,"bio_count":6,"fam":"Miridae","estimate":0.27,"lwr_95":-0.47,"upr_95":1.08,"scaled_estimate":0.5671},{"Order":"Tetraodontiformes","Family":"Monacanthidae","sp_count":20,"obs_count":20,"bio_count":2,"fam":"Monacanthidae","estimate":-0.01,"lwr_95":-1.31,"upr_95":1.36,"scaled_estimate":0.4975},{"Order":"Passeriformes","Family":"Monarchidae","sp_count":14,"obs_count":15,"bio_count":4,"fam":"Monarchidae","estimate":0.59,"lwr_95":-1.11,"upr_95":1.92,"scaled_estimate":0.6434},{"Order":"Rosales","Family":"Moraceae","sp_count":18,"obs_count":48,"bio_count":11,"fam":"Moraceae","estimate":0.14,"lwr_95":-1.6,"upr_95":1.83,"scaled_estimate":0.5349},{"Order":"Passeriformes","Family":"Motacillidae","sp_count":29,"obs_count":134,"bio_count":24,"fam":"Motacillidae","estimate":0.31,"lwr_95":-0.61,"upr_95":1.23,"scaled_estimate":0.5769},{"Order":"Perciformes","Family":"Mullidae","sp_count":15,"obs_count":15,"bio_count":3,"fam":"Mullidae","estimate":-0.31,"lwr_95":-1.62,"upr_95":1.09,"scaled_estimate":0.4231},{"Order":"Neogastropoda","Family":"Muricidae","sp_count":16,"obs_count":19,"bio_count":6,"fam":"Muricidae","estimate":-0.05,"lwr_95":-1.32,"upr_95":1.23,"scaled_estimate":0.4875},{"Order":"Rodentia","Family":"Muridae","sp_count":36,"obs_count":69,"bio_count":13,"fam":"Muridae","estimate":1.1,"lwr_95":-0.66,"upr_95":2.73,"scaled_estimate":0.7503},{"Order":"Passeriformes","Family":"Muscicapidae","sp_count":104,"obs_count":257,"bio_count":23,"fam":"Muscicapidae","estimate":-0.48,"lwr_95":-1.33,"upr_95":0.33,"scaled_estimate":0.3823},{"Order":"Diptera","Family":"Muscidae","sp_count":39,"obs_count":63,"bio_count":4,"fam":"Muscidae","estimate":-0.41,"lwr_95":-1.25,"upr_95":0.61,"scaled_estimate":0.3989},{"Order":"Musophagiformes","Family":"Musophagidae","sp_count":13,"obs_count":15,"bio_count":4,"fam":"Musophagidae","estimate":0.1,"lwr_95":-1.31,"upr_95":1.36,"scaled_estimate":0.525},{"Order":"Carnivora","Family":"Mustelidae","sp_count":14,"obs_count":44,"bio_count":9,"fam":"Mustelidae","estimate":-0.33,"lwr_95":-1.18,"upr_95":0.49,"scaled_estimate":0.4182},{"Order":"Anura","Family":"Myobatrachidae","sp_count":36,"obs_count":36,"bio_count":1,"fam":"Myobatrachidae","estimate":-0.37,"lwr_95":-1.15,"upr_95":0.45,"scaled_estimate":0.4085},{"Order":"Myrtales","Family":"Myrtaceae","sp_count":123,"obs_count":131,"bio_count":7,"fam":"Myrtaceae","estimate":-0.21,"lwr_95":-1.15,"upr_95":0.82,"scaled_estimate":0.4477},{"Order":"Squamata","Family":"Natricidae","sp_count":27,"obs_count":60,"bio_count":12,"fam":"Natricidae","estimate":-0.54,"lwr_95":-1.61,"upr_95":0.68,"scaled_estimate":0.3682},{"Order":"Passeriformes","Family":"Nectariniidae","sp_count":33,"obs_count":51,"bio_count":9,"fam":"Nectariniidae","estimate":-0.17,"lwr_95":-1.63,"upr_95":1.29,"scaled_estimate":0.4576},{"Order":"Lepidoptera","Family":"Nepticulidae","sp_count":12,"obs_count":12,"bio_count":2,"fam":"Nepticulidae","estimate":-0.35,"lwr_95":-1.81,"upr_95":1.29,"scaled_estimate":0.4134},{"Order":"Coleoptera","Family":"Nitidulidae","sp_count":14,"obs_count":23,"bio_count":3,"fam":"Nitidulidae","estimate":-0.16,"lwr_95":-0.91,"upr_95":0.67,"scaled_estimate":0.4601},{"Order":"Lepidoptera","Family":"Noctuidae","sp_count":600,"obs_count":1143,"bio_count":17,"fam":"Noctuidae","estimate":0.86,"lwr_95":0.14,"upr_95":1.56,"scaled_estimate":0.7027},{"Order":"Lepidoptera","Family":"Nolidae","sp_count":10,"obs_count":22,"bio_count":3,"fam":"Nolidae","estimate":0.36,"lwr_95":-0.46,"upr_95":1.04,"scaled_estimate":0.589},{"Order":"Lepidoptera","Family":"Notodontidae","sp_count":66,"obs_count":110,"bio_count":9,"fam":"Notodontidae","estimate":-0.5,"lwr_95":-1.68,"upr_95":0.77,"scaled_estimate":0.3775},{"Order":"Lepidoptera","Family":"Nymphalidae","sp_count":353,"obs_count":810,"bio_count":33,"fam":"Nymphalidae","estimate":0.95,"lwr_95":0.44,"upr_95":1.47,"scaled_estimate":0.7211},{"Order":"Lepidoptera","Family":"Oecophoridae","sp_count":31,"obs_count":45,"bio_count":6,"fam":"Oecophoridae","estimate":-0.1,"lwr_95":-1.11,"upr_95":0.95,"scaled_estimate":0.475},{"Order":"Lamiales","Family":"Oleaceae","sp_count":34,"obs_count":90,"bio_count":15,"fam":"Oleaceae","estimate":0.64,"lwr_95":-0.81,"upr_95":2.08,"scaled_estimate":0.6548},{"Order":"Myrtales","Family":"Onagraceae","sp_count":49,"obs_count":123,"bio_count":15,"fam":"Onagraceae","estimate":0.99,"lwr_95":0.04,"upr_95":1.86,"scaled_estimate":0.7291},{"Order":"Asparagales","Family":"Orchidaceae","sp_count":91,"obs_count":222,"bio_count":14,"fam":"Orchidaceae","estimate":0.36,"lwr_95":-0.11,"upr_95":0.77,"scaled_estimate":0.589},{"Order":"Lamiales","Family":"Orobanchaceae","sp_count":70,"obs_count":130,"bio_count":12,"fam":"Orobanchaceae","estimate":0.3,"lwr_95":-0.48,"upr_95":1.01,"scaled_estimate":0.5744},{"Order":"Otidiformes","Family":"Otididae","sp_count":12,"obs_count":19,"bio_count":5,"fam":"Otididae","estimate":-0.01,"lwr_95":-0.19,"upr_95":0.18,"scaled_estimate":0.4975},{"Order":"Oxalidales","Family":"Oxalidaceae","sp_count":12,"obs_count":53,"bio_count":15,"fam":"Oxalidaceae","estimate":0.79,"lwr_95":-0.72,"upr_95":2.26,"scaled_estimate":0.6878},{"Order":"Passeriformes","Family":"Pachycephalidae","sp_count":12,"obs_count":13,"bio_count":2,"fam":"Pachycephalidae","estimate":-0.26,"lwr_95":-1.47,"upr_95":1.11,"scaled_estimate":0.4354},{"Order":"Decapoda","Family":"Palaemonidae","sp_count":10,"obs_count":15,"bio_count":4,"fam":"Palaemonidae","estimate":0.07,"lwr_95":-1.16,"upr_95":1.23,"scaled_estimate":0.5175},{"Order":"Ranunculales","Family":"Papaveraceae","sp_count":39,"obs_count":112,"bio_count":18,"fam":"Papaveraceae","estimate":0.75,"lwr_95":-0.53,"upr_95":1.97,"scaled_estimate":0.6792},{"Order":"Lepidoptera","Family":"Papilionidae","sp_count":50,"obs_count":104,"bio_count":17,"fam":"Papilionidae","estimate":0.32,"lwr_95":-0.92,"upr_95":1.62,"scaled_estimate":0.5793},{"Order":"Passeriformes","Family":"Paridae","sp_count":26,"obs_count":74,"bio_count":17,"fam":"Paridae","estimate":0.64,"lwr_95":-0.43,"upr_95":1.69,"scaled_estimate":0.6548},{"Order":"Passeriformes","Family":"Parulidae","sp_count":62,"obs_count":206,"bio_count":13,"fam":"Parulidae","estimate":-0.01,"lwr_95":-1.03,"upr_95":1.01,"scaled_estimate":0.4975},{"Order":"Passeriformes","Family":"Passeridae","sp_count":23,"obs_count":71,"bio_count":21,"fam":"Passeridae","estimate":-0.02,"lwr_95":-1.72,"upr_95":1.69,"scaled_estimate":0.495},{"Order":"Hemiptera","Family":"Pentatomidae","sp_count":54,"obs_count":116,"bio_count":11,"fam":"Pentatomidae","estimate":0.34,"lwr_95":-0.77,"upr_95":1.45,"scaled_estimate":0.5842},{"Order":"Passeriformes","Family":"Petroicidae","sp_count":18,"obs_count":18,"bio_count":2,"fam":"Petroicidae","estimate":-0.05,"lwr_95":-1.12,"upr_95":1.08,"scaled_estimate":0.4875},{"Order":"Suliformes","Family":"Phalacrocoracidae","sp_count":19,"obs_count":51,"bio_count":20,"fam":"Phalacrocoracidae","estimate":-0.1,"lwr_95":-1.01,"upr_95":0.81,"scaled_estimate":0.475},{"Order":"Galliformes","Family":"Phasianidae","sp_count":51,"obs_count":123,"bio_count":27,"fam":"Phasianidae","estimate":0.44,"lwr_95":-0.91,"upr_95":1.72,"scaled_estimate":0.6083},{"Order":"Araneae","Family":"Philodromidae","sp_count":11,"obs_count":17,"bio_count":3,"fam":"Philodromidae","estimate":-0.46,"lwr_95":-1.69,"upr_95":0.97,"scaled_estimate":0.387},{"Order":"Lamiales","Family":"Phrymaceae","sp_count":10,"obs_count":13,"bio_count":4,"fam":"Phrymaceae","estimate":0.22,"lwr_95":-1.31,"upr_95":1.69,"scaled_estimate":0.5548},{"Order":"Squamata","Family":"Phrynosomatidae","sp_count":39,"obs_count":69,"bio_count":6,"fam":"Phrynosomatidae","estimate":0.56,"lwr_95":-0.72,"upr_95":1.76,"scaled_estimate":0.6365},{"Order":"Malpighiales","Family":"Phyllanthaceae","sp_count":10,"obs_count":12,"bio_count":3,"fam":"Phyllanthaceae","estimate":0.33,"lwr_95":-1.38,"upr_95":2.01,"scaled_estimate":0.5818},{"Order":"Passeriformes","Family":"Phylloscopidae","sp_count":18,"obs_count":56,"bio_count":10,"fam":"Phylloscopidae","estimate":-0.49,"lwr_95":-1.88,"upr_95":1.05,"scaled_estimate":0.3799},{"Order":"Piciformes","Family":"Picidae","sp_count":71,"obs_count":166,"bio_count":26,"fam":"Picidae","estimate":-0.72,"lwr_95":-1.6,"upr_95":0.2,"scaled_estimate":0.3274},{"Order":"Lepidoptera","Family":"Pieridae","sp_count":94,"obs_count":233,"bio_count":24,"fam":"Pieridae","estimate":0.66,"lwr_95":-0.16,"upr_95":1.47,"scaled_estimate":0.6593},{"Order":"Pinales","Family":"Pinaceae","sp_count":70,"obs_count":171,"bio_count":18,"fam":"Pinaceae","estimate":0.64,"lwr_95":-0.13,"upr_95":1.37,"scaled_estimate":0.6548},{"Order":"Passeriformes","Family":"Pipridae","sp_count":10,"obs_count":10,"bio_count":2,"fam":"Pipridae","estimate":0.12,"lwr_95":-0.78,"upr_95":0.97,"scaled_estimate":0.53},{"Order":"Apiales","Family":"Pittosporaceae","sp_count":11,"obs_count":13,"bio_count":4,"fam":"Pittosporaceae","estimate":0.09,"lwr_95":-1.5,"upr_95":1.55,"scaled_estimate":0.5225},{"Family":"Planorbidae","sp_count":11,"obs_count":20,"bio_count":2,"fam":"Planorbidae","estimate":0.01,"lwr_95":-1.38,"upr_95":1.41,"scaled_estimate":0.5025},{"Order":"Lamiales","Family":"Plantaginaceae","sp_count":118,"obs_count":356,"bio_count":22,"fam":"Plantaginaceae","estimate":-0.53,"lwr_95":-1.51,"upr_95":0.36,"scaled_estimate":0.3705},{"Order":"Caudata","Family":"Plethodontidae","sp_count":24,"obs_count":25,"bio_count":3,"fam":"Plethodontidae","estimate":0.11,"lwr_95":-1.45,"upr_95":1.57,"scaled_estimate":0.5275},{"Order":"Passeriformes","Family":"Ploceidae","sp_count":36,"obs_count":52,"bio_count":6,"fam":"Ploceidae","estimate":0.31,"lwr_95":-0.73,"upr_95":1.36,"scaled_estimate":0.5769},{"Order":"Caryophyllales","Family":"Plumbaginaceae","sp_count":14,"obs_count":27,"bio_count":8,"fam":"Plumbaginaceae","estimate":0.97,"lwr_95":-1.05,"upr_95":2.96,"scaled_estimate":0.7251},{"Order":"Poales","Family":"Poaceae","sp_count":427,"obs_count":1026,"bio_count":20,"fam":"Poaceae","estimate":-0.19,"lwr_95":-1.08,"upr_95":0.63,"scaled_estimate":0.4526},{"Order":"Podicipediformes","Family":"Podicipedidae","sp_count":14,"obs_count":78,"bio_count":21,"fam":"Podicipedidae","estimate":-0.83,"lwr_95":-1.73,"upr_95":0.09,"scaled_estimate":0.3036},{"Order":"Ericales","Family":"Polemoniaceae","sp_count":17,"obs_count":29,"bio_count":7,"fam":"Polemoniaceae","estimate":0.37,"lwr_95":-1.06,"upr_95":1.69,"scaled_estimate":0.5915},{"Order":"Fabales","Family":"Polygalaceae","sp_count":19,"obs_count":32,"bio_count":8,"fam":"Polygalaceae","estimate":0.72,"lwr_95":-1.07,"upr_95":2.42,"scaled_estimate":0.6726},{"Order":"Caryophyllales","Family":"Polygonaceae","sp_count":77,"obs_count":222,"bio_count":19,"fam":"Polygonaceae","estimate":0.96,"lwr_95":-0.33,"upr_95":2.07,"scaled_estimate":0.7231},{"Order":"Perciformes","Family":"Pomacanthidae","sp_count":21,"obs_count":25,"bio_count":4,"fam":"Pomacanthidae","estimate":-0.02,"lwr_95":-0.69,"upr_95":0.6,"scaled_estimate":0.495},{"Order":"Perciformes","Family":"Pomacentridae","sp_count":80,"obs_count":101,"bio_count":8,"fam":"Pomacentridae","estimate":0.66,"lwr_95":-0.01,"upr_95":1.36,"scaled_estimate":0.6593},{"Order":"Hymenoptera","Family":"Pompilidae","sp_count":14,"obs_count":19,"bio_count":3,"fam":"Pompilidae","estimate":-0.19,"lwr_95":-1.35,"upr_95":1.02,"scaled_estimate":0.4526},{"Order":"Alismatales","Family":"Potamogetonaceae","sp_count":20,"obs_count":41,"bio_count":4,"fam":"Potamogetonaceae","estimate":0.55,"lwr_95":-0.46,"upr_95":1.37,"scaled_estimate":0.6341},{"Order":"Ericales","Family":"Primulaceae","sp_count":49,"obs_count":116,"bio_count":16,"fam":"Primulaceae","estimate":0.35,"lwr_95":-0.69,"upr_95":1.38,"scaled_estimate":0.5866},{"Order":"Procellariiformes","Family":"Procellariidae","sp_count":27,"obs_count":56,"bio_count":12,"fam":"Procellariidae","estimate":0.21,"lwr_95":-1.13,"upr_95":1.42,"scaled_estimate":0.5523},{"Order":"Proteales","Family":"Proteaceae","sp_count":64,"obs_count":65,"bio_count":2,"fam":"Proteaceae","estimate":0.6,"lwr_95":-0.97,"upr_95":1.8,"scaled_estimate":0.6457},{"Order":"Psittaciformes","Family":"Psittacidae","sp_count":88,"obs_count":113,"bio_count":21,"fam":"Psittacidae","estimate":-0.24,"lwr_95":-1.95,"upr_95":1.54,"scaled_estimate":0.4403},{"Order":"Lepidoptera","Family":"Pterophoridae","sp_count":17,"obs_count":34,"bio_count":4,"fam":"Pterophoridae","estimate":0.3,"lwr_95":-1.09,"upr_95":1.49,"scaled_estimate":0.5744},{"Order":"Passeriformes","Family":"Pycnonotidae","sp_count":34,"obs_count":57,"bio_count":11,"fam":"Pycnonotidae","estimate":-0.45,"lwr_95":-2.08,"upr_95":1.18,"scaled_estimate":0.3894},{"Order":"Squamata","Family":"Pygopodidae","sp_count":10,"obs_count":10,"bio_count":1,"fam":"Pygopodidae","estimate":-0.1,"lwr_95":-0.83,"upr_95":0.64,"scaled_estimate":0.475},{"Order":"Lepidoptera","Family":"Pyralidae","sp_count":72,"obs_count":122,"bio_count":8,"fam":"Pyralidae","estimate":0.21,"lwr_95":-0.86,"upr_95":1.19,"scaled_estimate":0.5523},{"Order":"Gruiformes","Family":"Rallidae","sp_count":39,"obs_count":128,"bio_count":28,"fam":"Rallidae","estimate":0.39,"lwr_95":-0.66,"upr_95":1.45,"scaled_estimate":0.5963},{"Order":"Piciformes","Family":"Ramphastidae","sp_count":49,"obs_count":69,"bio_count":13,"fam":"Ramphastidae","estimate":-0.8,"lwr_95":-2.05,"upr_95":0.53,"scaled_estimate":0.31},{"Order":"Anura","Family":"Ranidae","sp_count":28,"obs_count":53,"bio_count":12,"fam":"Ranidae","estimate":0.25,"lwr_95":-0.7,"upr_95":1.18,"scaled_estimate":0.5622},{"Order":"Ranunculales","Family":"Ranunculaceae","sp_count":122,"obs_count":308,"bio_count":16,"fam":"Ranunculaceae","estimate":0.81,"lwr_95":0.21,"upr_95":1.4,"scaled_estimate":0.6921},{"Order":"Hemiptera","Family":"Reduviidae","sp_count":22,"obs_count":34,"bio_count":6,"fam":"Reduviidae","estimate":-0.12,"lwr_95":-1.7,"upr_95":1.5,"scaled_estimate":0.47},{"Order":"Rosales","Family":"Rhamnaceae","sp_count":40,"obs_count":64,"bio_count":12,"fam":"Rhamnaceae","estimate":0.81,"lwr_95":-0.59,"upr_95":2.18,"scaled_estimate":0.6921},{"Order":"Hemiptera","Family":"Rhyparochromidae","sp_count":25,"obs_count":39,"bio_count":3,"fam":"Rhyparochromidae","estimate":0.4,"lwr_95":-0.66,"upr_95":1.32,"scaled_estimate":0.5987},{"Order":"Rosales","Family":"Rosaceae","sp_count":263,"obs_count":735,"bio_count":20,"fam":"Rosaceae","estimate":1.78,"lwr_95":0.91,"upr_95":2.44,"scaled_estimate":0.8557},{"Order":"Gentianales","Family":"Rubiaceae","sp_count":79,"obs_count":176,"bio_count":19,"fam":"Rubiaceae","estimate":-0.88,"lwr_95":-1.97,"upr_95":0.26,"scaled_estimate":0.2932},{"Order":"Sapindales","Family":"Rutaceae","sp_count":30,"obs_count":42,"bio_count":9,"fam":"Rutaceae","estimate":0.12,"lwr_95":-1.28,"upr_95":1.52,"scaled_estimate":0.53},{"Order":"Sabellida","Family":"Sabellidae","sp_count":12,"obs_count":18,"bio_count":3,"fam":"Sabellidae","estimate":0.22,"lwr_95":-0.7,"upr_95":1.08,"scaled_estimate":0.5548},{"Order":"Caudata","Family":"Salamandridae","sp_count":14,"obs_count":27,"bio_count":6,"fam":"Salamandridae","estimate":-0.7,"lwr_95":-1.84,"upr_95":0.41,"scaled_estimate":0.3318},{"Order":"Malpighiales","Family":"Salicaceae","sp_count":57,"obs_count":138,"bio_count":13,"fam":"Salicaceae","estimate":2.58,"lwr_95":1.2,"upr_95":3.54,"scaled_estimate":0.9296},{"Order":"Salmoniformes","Family":"Salmonidae","sp_count":14,"obs_count":38,"bio_count":7,"fam":"Salmonidae","estimate":0.57,"lwr_95":-0.59,"upr_95":1.68,"scaled_estimate":0.6388},{"Order":"Araneae","Family":"Salticidae","sp_count":66,"obs_count":114,"bio_count":15,"fam":"Salticidae","estimate":-0.72,"lwr_95":-1.98,"upr_95":0.62,"scaled_estimate":0.3274},{"Order":"Santalales","Family":"Santalaceae","sp_count":16,"obs_count":26,"bio_count":8,"fam":"Santalaceae","estimate":0.45,"lwr_95":-1.12,"upr_95":2.02,"scaled_estimate":0.6106},{"Order":"Sapindales","Family":"Sapindaceae","sp_count":39,"obs_count":107,"bio_count":15,"fam":"Sapindaceae","estimate":0.82,"lwr_95":-0.65,"upr_95":2.2,"scaled_estimate":0.6942},{"Order":"Diptera","Family":"Sarcophagidae","sp_count":11,"obs_count":15,"bio_count":2,"fam":"Sarcophagidae","estimate":0.48,"lwr_95":-1.02,"upr_95":1.74,"scaled_estimate":0.6177},{"Order":"Lepidoptera","Family":"Saturniidae","sp_count":16,"obs_count":34,"bio_count":7,"fam":"Saturniidae","estimate":1.27,"lwr_95":-0.33,"upr_95":2.65,"scaled_estimate":0.7807},{"Order":"Saxifragales","Family":"Saxifragaceae","sp_count":38,"obs_count":73,"bio_count":9,"fam":"Saxifragaceae","estimate":0.91,"lwr_95":-0.57,"upr_95":2.21,"scaled_estimate":0.713},{"Order":"Coleoptera","Family":"Scarabaeidae","sp_count":29,"obs_count":32,"bio_count":6,"fam":"Scarabaeidae","estimate":0.25,"lwr_95":-0.57,"upr_95":1.17,"scaled_estimate":0.5622},{"Order":"Perciformes","Family":"Scaridae","sp_count":31,"obs_count":36,"bio_count":4,"fam":"Scaridae","estimate":-0.08,"lwr_95":-0.33,"upr_95":0.14,"scaled_estimate":0.48},{"Order":"Squamata","Family":"Scincidae","sp_count":115,"obs_count":123,"bio_count":11,"fam":"Scincidae","estimate":0.32,"lwr_95":-1.17,"upr_95":1.71,"scaled_estimate":0.5793},{"Order":"Diptera","Family":"Sciomyzidae","sp_count":16,"obs_count":22,"bio_count":3,"fam":"Sciomyzidae","estimate":0.17,"lwr_95":-0.5,"upr_95":0.8,"scaled_estimate":0.5424},{"Order":"Rodentia","Family":"Sciuridae","sp_count":58,"obs_count":105,"bio_count":20,"fam":"Sciuridae","estimate":0.86,"lwr_95":-0.73,"upr_95":2.37,"scaled_estimate":0.7027},{"Order":"Charadriiformes","Family":"Scolopacidae","sp_count":62,"obs_count":477,"bio_count":35,"fam":"Scolopacidae","estimate":0.08,"lwr_95":-0.38,"upr_95":0.53,"scaled_estimate":0.52},{"Order":"Lamiales","Family":"Scrophulariaceae","sp_count":38,"obs_count":82,"bio_count":13,"fam":"Scrophulariaceae","estimate":0.88,"lwr_95":-0.22,"upr_95":1.87,"scaled_estimate":0.7068},{"Order":"Perciformes","Family":"Serranidae","sp_count":38,"obs_count":39,"bio_count":5,"fam":"Serranidae","estimate":-0.06,"lwr_95":-0.7,"upr_95":0.54,"scaled_estimate":0.485},{"Order":"Lepidoptera","Family":"Sesiidae","sp_count":13,"obs_count":17,"bio_count":3,"fam":"Sesiidae","estimate":-0.13,"lwr_95":-1.47,"upr_95":1.34,"scaled_estimate":0.4675},{"Order":"Coleoptera","Family":"Silphidae","sp_count":21,"obs_count":37,"bio_count":5,"fam":"Silphidae","estimate":0.19,"lwr_95":-0.81,"upr_95":1.23,"scaled_estimate":0.5474},{"Order":"Passeriformes","Family":"Sittidae","sp_count":11,"obs_count":30,"bio_count":11,"fam":"Sittidae","estimate":-0.4,"lwr_95":-1.71,"upr_95":0.94,"scaled_estimate":0.4013},{"Order":"Solanales","Family":"Solanaceae","sp_count":54,"obs_count":179,"bio_count":23,"fam":"Solanaceae","estimate":0.01,"lwr_95":-1.01,"upr_95":1.03,"scaled_estimate":0.5025},{"Order":"Soricomorpha","Family":"Soricidae","sp_count":14,"obs_count":25,"bio_count":7,"fam":"Soricidae","estimate":0.32,"lwr_95":-0.56,"upr_95":1.14,"scaled_estimate":0.5793},{"Order":"Perciformes","Family":"Sparidae","sp_count":15,"obs_count":17,"bio_count":3,"fam":"Sparidae","estimate":0.08,"lwr_95":-1.33,"upr_95":1.46,"scaled_estimate":0.52},{"Order":"Hymenoptera","Family":"Sphecidae","sp_count":18,"obs_count":35,"bio_count":7,"fam":"Sphecidae","estimate":0.07,"lwr_95":-1.36,"upr_95":1.55,"scaled_estimate":0.5175},{"Order":"Lepidoptera","Family":"Sphingidae","sp_count":57,"obs_count":133,"bio_count":14,"fam":"Sphingidae","estimate":0.54,"lwr_95":-0.25,"upr_95":1.32,"scaled_estimate":0.6318},{"Order":"Spionida","Family":"Spionidae","sp_count":21,"obs_count":21,"bio_count":1,"fam":"Spionidae","estimate":-0.03,"lwr_95":-0.48,"upr_95":0.43,"scaled_estimate":0.4925},{"Order":"Coleoptera","Family":"Staphylinidae","sp_count":233,"obs_count":357,"bio_count":5,"fam":"Staphylinidae","estimate":0.2,"lwr_95":-0.07,"upr_95":0.46,"scaled_estimate":0.5498},{"Order":"Diptera","Family":"Stratiomyidae","sp_count":27,"obs_count":34,"bio_count":3,"fam":"Stratiomyidae","estimate":-0.51,"lwr_95":-1.88,"upr_95":0.9,"scaled_estimate":0.3752},{"Order":"Strigiformes","Family":"Strigidae","sp_count":43,"obs_count":107,"bio_count":26,"fam":"Strigidae","estimate":-0.29,"lwr_95":-1.24,"upr_95":0.66,"scaled_estimate":0.428},{"Order":"Passeriformes","Family":"Sturnidae","sp_count":43,"obs_count":92,"bio_count":20,"fam":"Sturnidae","estimate":0.8,"lwr_95":-0.87,"upr_95":2.46,"scaled_estimate":0.69},{"Order":"Stolidobranchia","Family":"Styelidae","sp_count":11,"obs_count":18,"bio_count":4,"fam":"Styelidae","estimate":-0.42,"lwr_95":-2.07,"upr_95":1.29,"scaled_estimate":0.3965},{"Order":"Phyllodocida","Family":"Syllidae","sp_count":14,"obs_count":14,"bio_count":1,"fam":"Syllidae","estimate":-0.01,"lwr_95":-0.28,"upr_95":0.26,"scaled_estimate":0.4975},{"Order":"Passeriformes","Family":"Sylviidae","sp_count":21,"obs_count":67,"bio_count":11,"fam":"Sylviidae","estimate":-0.15,"lwr_95":-1.89,"upr_95":1.59,"scaled_estimate":0.4626},{"Order":"Syngnathiformes","Family":"Syngnathidae","sp_count":10,"obs_count":12,"bio_count":4,"fam":"Syngnathidae","estimate":-0.27,"lwr_95":-1.8,"upr_95":1.24,"scaled_estimate":0.4329},{"Order":"Diptera","Family":"Syrphidae","sp_count":185,"obs_count":390,"bio_count":11,"fam":"Syrphidae","estimate":0.36,"lwr_95":-0.54,"upr_95":1.18,"scaled_estimate":0.589},{"Order":"Diptera","Family":"Tabanidae","sp_count":15,"obs_count":27,"bio_count":3,"fam":"Tabanidae","estimate":0.19,"lwr_95":-0.82,"upr_95":1.11,"scaled_estimate":0.5474},{"Order":"Diptera","Family":"Tachinidae","sp_count":53,"obs_count":73,"bio_count":5,"fam":"Tachinidae","estimate":-0.78,"lwr_95":-2.09,"upr_95":0.82,"scaled_estimate":0.3143},{"Order":"Squamata","Family":"Teiidae","sp_count":13,"obs_count":19,"bio_count":6,"fam":"Teiidae","estimate":0.19,"lwr_95":-1.05,"upr_95":1.52,"scaled_estimate":0.5474},{"Order":"Coleoptera","Family":"Tenebrionidae","sp_count":27,"obs_count":34,"bio_count":6,"fam":"Tenebrionidae","estimate":0.37,"lwr_95":-0.84,"upr_95":1.53,"scaled_estimate":0.5915},{"Order":"Hymenoptera","Family":"Tenthredinidae","sp_count":30,"obs_count":46,"bio_count":3,"fam":"Tenthredinidae","estimate":-0.36,"lwr_95":-1.49,"upr_95":1.12,"scaled_estimate":0.411},{"Order":"Diptera","Family":"Tephritidae","sp_count":18,"obs_count":24,"bio_count":3,"fam":"Tephritidae","estimate":-0.22,"lwr_95":-1.58,"upr_95":1.14,"scaled_estimate":0.4452},{"Order":"Araneae","Family":"Tetragnathidae","sp_count":14,"obs_count":30,"bio_count":4,"fam":"Tetragnathidae","estimate":0.39,"lwr_95":-0.48,"upr_95":1.2,"scaled_estimate":0.5963},{"Order":"Tetraodontiformes","Family":"Tetraodontidae","sp_count":11,"obs_count":11,"bio_count":2,"fam":"Tetraodontidae","estimate":-0.24,"lwr_95":-1.45,"upr_95":1.09,"scaled_estimate":0.4403},{"Order":"Orthoptera","Family":"Tettigoniidae","sp_count":44,"obs_count":91,"bio_count":9,"fam":"Tettigoniidae","estimate":0.2,"lwr_95":-1.11,"upr_95":1.5,"scaled_estimate":0.5498},{"Order":"Passeriformes","Family":"Thamnophilidae","sp_count":14,"obs_count":15,"bio_count":2,"fam":"Thamnophilidae","estimate":0.18,"lwr_95":-1.32,"upr_95":1.58,"scaled_estimate":0.5449},{"Order":"Araneae","Family":"Theridiidae","sp_count":39,"obs_count":68,"bio_count":11,"fam":"Theridiidae","estimate":0.44,"lwr_95":-1.37,"upr_95":2.23,"scaled_estimate":0.6083},{"Order":"Araneae","Family":"Thomisidae","sp_count":22,"obs_count":37,"bio_count":6,"fam":"Thomisidae","estimate":0.18,"lwr_95":-1.23,"upr_95":1.51,"scaled_estimate":0.5449},{"Order":"Passeriformes","Family":"Thraupidae","sp_count":96,"obs_count":135,"bio_count":9,"fam":"Thraupidae","estimate":-0.18,"lwr_95":-1.74,"upr_95":1.42,"scaled_estimate":0.4551},{"Order":"Pelecaniformes","Family":"Threskiornithidae","sp_count":25,"obs_count":84,"bio_count":24,"fam":"Threskiornithidae","estimate":-0.33,"lwr_95":-1.38,"upr_95":0.72,"scaled_estimate":0.4182},{"Order":"Malvales","Family":"Thymelaeaceae","sp_count":15,"obs_count":23,"bio_count":5,"fam":"Thymelaeaceae","estimate":-0.03,"lwr_95":-1.13,"upr_95":1.06,"scaled_estimate":0.4925},{"Order":"Lepidoptera","Family":"Tineidae","sp_count":22,"obs_count":34,"bio_count":5,"fam":"Tineidae","estimate":-0.89,"lwr_95":-2.08,"upr_95":0.78,"scaled_estimate":0.2911},{"Order":"Diptera","Family":"Tipulidae","sp_count":32,"obs_count":51,"bio_count":3,"fam":"Tipulidae","estimate":-0.25,"lwr_95":-1.06,"upr_95":0.63,"scaled_estimate":0.4378},{"Order":"Lepidoptera","Family":"Tortricidae","sp_count":278,"obs_count":492,"bio_count":9,"fam":"Tortricidae","estimate":-0.11,"lwr_95":-0.57,"upr_95":0.54,"scaled_estimate":0.4725},{"Order":"Trochida","Family":"Trochidae","sp_count":12,"obs_count":17,"bio_count":4,"fam":"Trochidae","estimate":0.74,"lwr_95":-0.51,"upr_95":1.88,"scaled_estimate":0.677},{"Order":"Apodiformes","Family":"Trochilidae","sp_count":85,"obs_count":115,"bio_count":11,"fam":"Trochilidae","estimate":-0.43,"lwr_95":-1.73,"upr_95":0.94,"scaled_estimate":0.3941},{"Order":"Passeriformes","Family":"Troglodytidae","sp_count":25,"obs_count":60,"bio_count":9,"fam":"Troglodytidae","estimate":-0.43,"lwr_95":-1.61,"upr_95":0.8,"scaled_estimate":0.3941},{"Order":"Trogoniformes","Family":"Trogonidae","sp_count":15,"obs_count":15,"bio_count":4,"fam":"Trogonidae","estimate":0.01,"lwr_95":-0.98,"upr_95":1.08,"scaled_estimate":0.5025},{"Order":"Passeriformes","Family":"Turdidae","sp_count":55,"obs_count":143,"bio_count":27,"fam":"Turdidae","estimate":1.13,"lwr_95":-0.3,"upr_95":2.42,"scaled_estimate":0.7558},{"Order":"Poales","Family":"Typhaceae","sp_count":12,"obs_count":32,"bio_count":7,"fam":"Typhaceae","estimate":1.68,"lwr_95":0.32,"upr_95":2.7,"scaled_estimate":0.8429},{"Order":"Passeriformes","Family":"Tyrannidae","sp_count":89,"obs_count":196,"bio_count":13,"fam":"Tyrannidae","estimate":1.37,"lwr_95":0.22,"upr_95":2.41,"scaled_estimate":0.7974},{"Order":"Rosales","Family":"Ulmaceae","sp_count":10,"obs_count":22,"bio_count":7,"fam":"Ulmaceae","estimate":-0.34,"lwr_95":-2.18,"upr_95":1.51,"scaled_estimate":0.4158},{"Order":"Unionida","Family":"Unionidae","sp_count":11,"obs_count":15,"bio_count":4,"fam":"Unionidae","estimate":0.68,"lwr_95":-0.57,"upr_95":1.69,"scaled_estimate":0.6637},{"Order":"Rosales","Family":"Urticaceae","sp_count":13,"obs_count":43,"bio_count":12,"fam":"Urticaceae","estimate":-0.95,"lwr_95":-2.85,"upr_95":0.99,"scaled_estimate":0.2789},{"Order":"Squamata","Family":"Varanidae","sp_count":13,"obs_count":14,"bio_count":3,"fam":"Varanidae","estimate":-0.16,"lwr_95":-1.67,"upr_95":1.32,"scaled_estimate":0.4601},{"Order":"Venerida","Family":"Veneridae","sp_count":31,"obs_count":43,"bio_count":6,"fam":"Veneridae","estimate":0.56,"lwr_95":-0.53,"upr_95":1.57,"scaled_estimate":0.6365},{"Order":"Lamiales","Family":"Verbenaceae","sp_count":13,"obs_count":60,"bio_count":19,"fam":"Verbenaceae","estimate":1.02,"lwr_95":-0.72,"upr_95":2.69,"scaled_estimate":0.735},{"Order":"Chiroptera","Family":"Vespertilionidae","sp_count":45,"obs_count":74,"bio_count":7,"fam":"Vespertilionidae","estimate":0.36,"lwr_95":-1,"upr_95":1.71,"scaled_estimate":0.589},{"Order":"Hymenoptera","Family":"Vespidae","sp_count":37,"obs_count":82,"bio_count":14,"fam":"Vespidae","estimate":0.07,"lwr_95":-1.11,"upr_95":1.26,"scaled_estimate":0.5175},{"Order":"Malpighiales","Family":"Violaceae","sp_count":45,"obs_count":103,"bio_count":13,"fam":"Violaceae","estimate":0.95,"lwr_95":-0.11,"upr_95":2.05,"scaled_estimate":0.7211},{"Order":"Squamata","Family":"Viperidae","sp_count":27,"obs_count":40,"bio_count":12,"fam":"Viperidae","estimate":-0.37,"lwr_95":-1.35,"upr_95":0.54,"scaled_estimate":0.4085},{"Order":"Passeriformes","Family":"Vireonidae","sp_count":14,"obs_count":38,"bio_count":8,"fam":"Vireonidae","estimate":-0.05,"lwr_95":-1.22,"upr_95":1.14,"scaled_estimate":0.4875},{"Order":"Vitales","Family":"Vitaceae","sp_count":10,"obs_count":25,"bio_count":8,"fam":"Vitaceae","estimate":-0.25,"lwr_95":-2.05,"upr_95":1.52,"scaled_estimate":0.4378},{"Order":"Lepidoptera","Family":"Yponomeutidae","sp_count":10,"obs_count":19,"bio_count":3,"fam":"Yponomeutidae","estimate":-0.33,"lwr_95":-1.31,"upr_95":0.72,"scaled_estimate":0.4182},{"Order":"Lepidoptera","Family":"Ypsolophidae","sp_count":13,"obs_count":25,"bio_count":3,"fam":"Ypsolophidae","estimate":0.01,"lwr_95":-1.3,"upr_95":1.33,"scaled_estimate":0.5025},{"Order":"Passeriformes","Family":"Zosteropidae","sp_count":12,"obs_count":12,"bio_count":6,"fam":"Zosteropidae","estimate":-0.19,"lwr_95":-1.97,"upr_95":1.61,"scaled_estimate":0.4526},{"Order":"Lepidoptera","Family":"Zygaenidae","sp_count":14,"obs_count":28,"bio_count":5,"fam":"Zygaenidae","estimate":0.38,"lwr_95":-0.41,"upr_95":1.29,"scaled_estimate":0.5939},{"Order":"Accipitriformes","Family":"Accipitriformes","sp_count":129,"obs_count":489,"bio_count":42,"fam":"Accipitriformes","estimate":-0.89,"lwr_95":-1.37,"upr_95":-0.39,"scaled_estimate":0.2911},{"Order":"Actiniaria","Family":"Actiniaria","sp_count":25,"obs_count":35,"bio_count":6,"fam":"Actiniaria","estimate":0.01,"lwr_95":-0.61,"upr_95":0.59,"scaled_estimate":0.5025},{"Order":"Alcyonacea","Family":"Alcyonacea","sp_count":12,"obs_count":14,"bio_count":4,"fam":"Alcyonacea","estimate":0,"lwr_95":-0.07,"upr_95":0.02,"scaled_estimate":0.5},{"Order":"Alismatales","Family":"Alismatales","sp_count":74,"obs_count":182,"bio_count":14,"fam":"Alismatales","estimate":0.33,"lwr_95":-0.52,"upr_95":1.41,"scaled_estimate":0.5818},{"Order":"Amphipoda","Family":"Amphipoda","sp_count":24,"obs_count":28,"bio_count":3,"fam":"Amphipoda","estimate":-0.12,"lwr_95":-1.57,"upr_95":1.27,"scaled_estimate":0.47},{"Order":"Anseriformes","Family":"Anseriformes","sp_count":129,"obs_count":655,"bio_count":42,"fam":"Anseriformes","estimate":0.43,"lwr_95":-0.28,"upr_95":1.12,"scaled_estimate":0.6059},{"Order":"Anura","Family":"Anura","sp_count":248,"obs_count":353,"bio_count":31,"fam":"Anura","estimate":0.74,"lwr_95":0.19,"upr_95":1.29,"scaled_estimate":0.677},{"Order":"Apiales","Family":"Apiales","sp_count":168,"obs_count":379,"bio_count":19,"fam":"Apiales","estimate":1.74,"lwr_95":0.55,"upr_95":2.75,"scaled_estimate":0.8507},{"Order":"Apodiformes","Family":"Apodiformes","sp_count":108,"obs_count":164,"bio_count":30,"fam":"Apodiformes","estimate":0.51,"lwr_95":-0.7,"upr_95":1.71,"scaled_estimate":0.6248},{"Order":"Aquifoliales","Family":"Aquifoliales","sp_count":11,"obs_count":19,"bio_count":4,"fam":"Aquifoliales","estimate":-0.26,"lwr_95":-2.08,"upr_95":1.59,"scaled_estimate":0.4354},{"Order":"Araneae","Family":"Araneae","sp_count":468,"obs_count":801,"bio_count":26,"fam":"Araneae","estimate":-0.72,"lwr_95":-1.78,"upr_95":0.34,"scaled_estimate":0.3274},{"Order":"Arecales","Family":"Arecales","sp_count":18,"obs_count":29,"bio_count":9,"fam":"Arecales","estimate":0.46,"lwr_95":-1.27,"upr_95":2.13,"scaled_estimate":0.613},{"Order":"Artiodactyla","Family":"Artiodactyla","sp_count":74,"obs_count":176,"bio_count":33,"fam":"Artiodactyla","estimate":-0.05,"lwr_95":-0.74,"upr_95":0.64,"scaled_estimate":0.4875},{"Order":"Asparagales","Family":"Asparagales","sp_count":280,"obs_count":643,"bio_count":23,"fam":"Asparagales","estimate":1.05,"lwr_95":-0.39,"upr_95":2.4,"scaled_estimate":0.7408},{"Order":"Asterales","Family":"Asterales","sp_count":722,"obs_count":1833,"bio_count":28,"fam":"Asterales","estimate":1,"lwr_95":0.35,"upr_95":1.66,"scaled_estimate":0.7311},{"Order":"Atheriniformes","Family":"Atheriniformes","sp_count":12,"obs_count":14,"bio_count":4,"fam":"Atheriniformes","estimate":0.35,"lwr_95":-1.56,"upr_95":2.21,"scaled_estimate":0.5866},{"Order":"Beryciformes","Family":"Beryciformes","sp_count":16,"obs_count":16,"bio_count":3,"fam":"Beryciformes","estimate":-0.07,"lwr_95":-0.93,"upr_95":0.8,"scaled_estimate":0.4825},{"Order":"Boraginales","Family":"Boraginales","sp_count":80,"obs_count":198,"bio_count":17,"fam":"Boraginales","estimate":1,"lwr_95":0.18,"upr_95":1.79,"scaled_estimate":0.7311},{"Order":"Brassicales","Family":"Brassicales","sp_count":189,"obs_count":521,"bio_count":24,"fam":"Brassicales","estimate":0.71,"lwr_95":-0.36,"upr_95":1.65,"scaled_estimate":0.6704},{"Order":"Bucerotiformes","Family":"Bucerotiformes","sp_count":30,"obs_count":66,"bio_count":20,"fam":"Bucerotiformes","estimate":-0.98,"lwr_95":-2.22,"upr_95":0.25,"scaled_estimate":0.2729},{"Order":"Caprimulgiformes","Family":"Caprimulgiformes","sp_count":19,"obs_count":28,"bio_count":18,"fam":"Caprimulgiformes","estimate":0.17,"lwr_95":-1.26,"upr_95":1.59,"scaled_estimate":0.5424},{"Order":"Carcharhiniformes","Family":"Carcharhiniformes","sp_count":15,"obs_count":18,"bio_count":6,"fam":"Carcharhiniformes","estimate":0.04,"lwr_95":-0.53,"upr_95":0.75,"scaled_estimate":0.51},{"Order":"Cardiida","Family":"Cardiida","sp_count":16,"obs_count":23,"bio_count":5,"fam":"Cardiida","estimate":0.34,"lwr_95":-1.16,"upr_95":1.47,"scaled_estimate":0.5842},{"Order":"Carnivora","Family":"Carnivora","sp_count":79,"obs_count":220,"bio_count":35,"fam":"Carnivora","estimate":-0.65,"lwr_95":-1.56,"upr_95":0.27,"scaled_estimate":0.343},{"Order":"Caryophyllales","Family":"Caryophyllales","sp_count":408,"obs_count":1040,"bio_count":26,"fam":"Caryophyllales","estimate":0.2,"lwr_95":-0.74,"upr_95":1.1,"scaled_estimate":0.5498},{"Order":"Caudata","Family":"Caudata","sp_count":49,"obs_count":69,"bio_count":10,"fam":"Caudata","estimate":-0.7,"lwr_95":-1.73,"upr_95":0.39,"scaled_estimate":0.3318},{"Order":"Celastrales","Family":"Celastrales","sp_count":21,"obs_count":45,"bio_count":13,"fam":"Celastrales","estimate":1.32,"lwr_95":-0.32,"upr_95":2.78,"scaled_estimate":0.7892},{"Order":"Cetacea","Family":"Cetacea","sp_count":28,"obs_count":74,"bio_count":18,"fam":"Cetacea","estimate":-0.49,"lwr_95":-1.09,"upr_95":0.04,"scaled_estimate":0.3799},{"Order":"Charadriiformes","Family":"Charadriiformes","sp_count":249,"obs_count":1183,"bio_count":43,"fam":"Charadriiformes","estimate":1.19,"lwr_95":0.49,"upr_95":1.9,"scaled_estimate":0.7667},{"Order":"Chiroptera","Family":"Chiroptera","sp_count":76,"obs_count":121,"bio_count":22,"fam":"Chiroptera","estimate":0.89,"lwr_95":-0.55,"upr_95":2.09,"scaled_estimate":0.7089},{"Order":"Ciconiiformes","Family":"Ciconiiformes","sp_count":16,"obs_count":55,"bio_count":23,"fam":"Ciconiiformes","estimate":-0.16,"lwr_95":-0.96,"upr_95":0.63,"scaled_estimate":0.4601},{"Order":"Coleoptera","Family":"Coleoptera","sp_count":1711,"obs_count":2816,"bio_count":26,"fam":"Coleoptera","estimate":-1.34,"lwr_95":-2.11,"upr_95":-0.57,"scaled_estimate":0.2075},{"Order":"Collembola","Family":"Collembola","sp_count":35,"obs_count":48,"bio_count":3,"fam":"Collembola","estimate":0.74,"lwr_95":-0.88,"upr_95":2.17,"scaled_estimate":0.677},{"Order":"Columbiformes","Family":"Columbiformes","sp_count":83,"obs_count":221,"bio_count":40,"fam":"Columbiformes","estimate":2.07,"lwr_95":0.62,"upr_95":3.46,"scaled_estimate":0.888},{"Order":"Coraciiformes","Family":"Coraciiformes","sp_count":69,"obs_count":195,"bio_count":37,"fam":"Coraciiformes","estimate":0.23,"lwr_95":-0.5,"upr_95":0.96,"scaled_estimate":0.5572},{"Order":"Cornales","Family":"Cornales","sp_count":23,"obs_count":60,"bio_count":12,"fam":"Cornales","estimate":0.64,"lwr_95":-0.86,"upr_95":2.06,"scaled_estimate":0.6548},{"Order":"Crassiclitellata","Family":"Crassiclitellata","sp_count":16,"obs_count":30,"bio_count":7,"fam":"Crassiclitellata","estimate":1.1,"lwr_95":0,"upr_95":2.16,"scaled_estimate":0.7503},{"Order":"Cuculiformes","Family":"Cuculiformes","sp_count":47,"obs_count":91,"bio_count":32,"fam":"Cuculiformes","estimate":0.46,"lwr_95":-1.04,"upr_95":1.89,"scaled_estimate":0.613},{"Order":"Cucurbitales","Family":"Cucurbitales","sp_count":14,"obs_count":31,"bio_count":7,"fam":"Cucurbitales","estimate":0.45,"lwr_95":-1.14,"upr_95":2.01,"scaled_estimate":0.6106},{"Order":"Cypriniformes","Family":"Cypriniformes","sp_count":60,"obs_count":104,"bio_count":12,"fam":"Cypriniformes","estimate":1.59,"lwr_95":0.7,"upr_95":2.44,"scaled_estimate":0.8306},{"Order":"Cyprinodontiformes","Family":"Cyprinodontiformes","sp_count":20,"obs_count":28,"bio_count":9,"fam":"Cyprinodontiformes","estimate":0.19,"lwr_95":-1.26,"upr_95":1.59,"scaled_estimate":0.5474},{"Order":"Dasyuromorphia","Family":"Dasyuromorphia","sp_count":24,"obs_count":24,"bio_count":1,"fam":"Dasyuromorphia","estimate":0.08,"lwr_95":-0.03,"upr_95":0.19,"scaled_estimate":0.52},{"Order":"Decapoda","Family":"Decapoda","sp_count":53,"obs_count":85,"bio_count":8,"fam":"Decapoda","estimate":0.15,"lwr_95":-0.7,"upr_95":1.03,"scaled_estimate":0.5374},{"Order":"Diprotodontia","Family":"Diprotodontia","sp_count":40,"obs_count":41,"bio_count":2,"fam":"Diprotodontia","estimate":-0.01,"lwr_95":-1.53,"upr_95":1.5,"scaled_estimate":0.4975},{"Order":"Dipsacales","Family":"Dipsacales","sp_count":79,"obs_count":219,"bio_count":17,"fam":"Dipsacales","estimate":1.72,"lwr_95":0.66,"upr_95":2.61,"scaled_estimate":0.8481},{"Order":"Diptera","Family":"Diptera","sp_count":772,"obs_count":1246,"bio_count":15,"fam":"Diptera","estimate":-0.12,"lwr_95":-0.54,"upr_95":0.37,"scaled_estimate":0.47},{"Order":"Ephemeroptera","Family":"Ephemeroptera","sp_count":25,"obs_count":47,"bio_count":4,"fam":"Ephemeroptera","estimate":0.15,"lwr_95":-0.63,"upr_95":0.9,"scaled_estimate":0.5374},{"Order":"Ericales","Family":"Ericales","sp_count":227,"obs_count":494,"bio_count":23,"fam":"Ericales","estimate":0.8,"lwr_95":-0.03,"upr_95":1.61,"scaled_estimate":0.69},{"Order":"Fabales","Family":"Fabales","sp_count":469,"obs_count":1029,"bio_count":30,"fam":"Fabales","estimate":1.96,"lwr_95":1.04,"upr_95":2.8,"scaled_estimate":0.8765},{"Order":"Fagales","Family":"Fagales","sp_count":119,"obs_count":261,"bio_count":18,"fam":"Fagales","estimate":0.43,"lwr_95":-0.69,"upr_95":1.49,"scaled_estimate":0.6059},{"Order":"Falconiformes","Family":"Falconiformes","sp_count":35,"obs_count":124,"bio_count":33,"fam":"Falconiformes","estimate":0.38,"lwr_95":-0.57,"upr_95":1.39,"scaled_estimate":0.5939},{"Order":"Forcipulatida","Family":"Forcipulatida","sp_count":12,"obs_count":17,"bio_count":6,"fam":"Forcipulatida","estimate":0.12,"lwr_95":-0.77,"upr_95":0.94,"scaled_estimate":0.53},{"Order":"Gadiformes","Family":"Gadiformes","sp_count":26,"obs_count":43,"bio_count":5,"fam":"Gadiformes","estimate":-0.19,"lwr_95":-0.64,"upr_95":0.24,"scaled_estimate":0.4526},{"Order":"Galliformes","Family":"Galliformes","sp_count":74,"obs_count":162,"bio_count":38,"fam":"Galliformes","estimate":0.36,"lwr_95":-0.79,"upr_95":1.48,"scaled_estimate":0.589},{"Order":"Gentianales","Family":"Gentianales","sp_count":164,"obs_count":371,"bio_count":26,"fam":"Gentianales","estimate":0.97,"lwr_95":-0.69,"upr_95":2.54,"scaled_estimate":0.7251},{"Order":"Geraniales","Family":"Geraniales","sp_count":37,"obs_count":130,"bio_count":17,"fam":"Geraniales","estimate":-0.49,"lwr_95":-1.57,"upr_95":0.57,"scaled_estimate":0.3799},{"Order":"Gruiformes","Family":"Gruiformes","sp_count":52,"obs_count":168,"bio_count":36,"fam":"Gruiformes","estimate":-0.78,"lwr_95":-1.69,"upr_95":0.12,"scaled_estimate":0.3143},{"Order":"Hemiptera","Family":"Hemiptera","sp_count":399,"obs_count":703,"bio_count":16,"fam":"Hemiptera","estimate":-0.39,"lwr_95":-1.7,"upr_95":0.94,"scaled_estimate":0.4037},{"Order":"Hymenoptera","Family":"Hymenoptera","sp_count":699,"obs_count":1275,"bio_count":31,"fam":"Hymenoptera","estimate":1.09,"lwr_95":0.06,"upr_95":2.05,"scaled_estimate":0.7484},{"Order":"Isopoda","Family":"Isopoda","sp_count":14,"obs_count":40,"bio_count":12,"fam":"Isopoda","estimate":0.06,"lwr_95":-1.62,"upr_95":1.86,"scaled_estimate":0.515},{"Order":"Julida","Family":"Julida","sp_count":13,"obs_count":16,"bio_count":3,"fam":"Julida","estimate":0.14,"lwr_95":-1.65,"upr_95":1.93,"scaled_estimate":0.5349},{"Order":"Lagomorpha","Family":"Lagomorpha","sp_count":18,"obs_count":52,"bio_count":19,"fam":"Lagomorpha","estimate":0.02,"lwr_95":-1.68,"upr_95":1.69,"scaled_estimate":0.505},{"Order":"Lamiales","Family":"Lamiales","sp_count":483,"obs_count":1300,"bio_count":26,"fam":"Lamiales","estimate":0.92,"lwr_95":0.02,"upr_95":1.75,"scaled_estimate":0.715},{"Order":"Laurales","Family":"Laurales","sp_count":20,"obs_count":25,"bio_count":5,"fam":"Laurales","estimate":0.42,"lwr_95":-1.24,"upr_95":2.06,"scaled_estimate":0.6035},{"Order":"Lepidoptera","Family":"Lepidoptera","sp_count":3189,"obs_count":6252,"bio_count":38,"fam":"Lepidoptera","estimate":0.13,"lwr_95":-0.3,"upr_95":0.58,"scaled_estimate":0.5325},{"Order":"Liliales","Family":"Liliales","sp_count":50,"obs_count":108,"bio_count":14,"fam":"Liliales","estimate":-0.13,"lwr_95":-1,"upr_95":0.69,"scaled_estimate":0.4675},{"Order":"Littorinimorpha","Family":"Littorinimorpha","sp_count":14,"obs_count":29,"bio_count":6,"fam":"Littorinimorpha","estimate":-0.14,"lwr_95":-1.31,"upr_95":0.97,"scaled_estimate":0.4651},{"Order":"Lycopodiales","Family":"Lycopodiales","sp_count":11,"obs_count":27,"bio_count":6,"fam":"Lycopodiales","estimate":0.04,"lwr_95":-0.19,"upr_95":0.23,"scaled_estimate":0.51},{"Order":"Magnoliales","Family":"Magnoliales","sp_count":11,"obs_count":19,"bio_count":4,"fam":"Magnoliales","estimate":0.25,"lwr_95":-1.56,"upr_95":2.05,"scaled_estimate":0.5622},{"Order":"Malpighiales","Family":"Malpighiales","sp_count":238,"obs_count":571,"bio_count":26,"fam":"Malpighiales","estimate":0.06,"lwr_95":-1.1,"upr_95":1.09,"scaled_estimate":0.515},{"Order":"Malvales","Family":"Malvales","sp_count":124,"obs_count":259,"bio_count":22,"fam":"Malvales","estimate":1.47,"lwr_95":0.17,"upr_95":2.62,"scaled_estimate":0.8131},{"Order":"Mantodea","Family":"Mantodea","sp_count":19,"obs_count":32,"bio_count":11,"fam":"Mantodea","estimate":0.16,"lwr_95":-1.51,"upr_95":1.83,"scaled_estimate":0.5399},{"Order":"Musophagiformes","Family":"Musophagiformes","sp_count":13,"obs_count":16,"bio_count":5,"fam":"Musophagiformes","estimate":0.11,"lwr_95":-1.27,"upr_95":1.36,"scaled_estimate":0.5275},{"Order":"Myrtales","Family":"Myrtales","sp_count":194,"obs_count":322,"bio_count":26,"fam":"Myrtales","estimate":1.6,"lwr_95":-0.08,"upr_95":3.11,"scaled_estimate":0.832},{"Order":"Neogastropoda","Family":"Neogastropoda","sp_count":32,"obs_count":40,"bio_count":8,"fam":"Neogastropoda","estimate":-0.17,"lwr_95":-1.04,"upr_95":0.73,"scaled_estimate":0.4576},{"Order":"Nudibranchia","Family":"Nudibranchia","sp_count":18,"obs_count":23,"bio_count":4,"fam":"Nudibranchia","estimate":0.37,"lwr_95":-0.32,"upr_95":0.98,"scaled_estimate":0.5915},{"Order":"Odonata","Family":"Odonata","sp_count":382,"obs_count":852,"bio_count":30,"fam":"Odonata","estimate":0,"lwr_95":-0.3,"upr_95":0.29,"scaled_estimate":0.5},{"Order":"Opiliones","Family":"Opiliones","sp_count":11,"obs_count":30,"bio_count":10,"fam":"Opiliones","estimate":0.91,"lwr_95":-0.75,"upr_95":2.47,"scaled_estimate":0.713},{"Order":"Orthoptera","Family":"Orthoptera","sp_count":189,"obs_count":351,"bio_count":19,"fam":"Orthoptera","estimate":0.12,"lwr_95":-1.14,"upr_95":1.34,"scaled_estimate":0.53},{"Order":"Otidiformes","Family":"Otidiformes","sp_count":15,"obs_count":24,"bio_count":10,"fam":"Otidiformes","estimate":-0.01,"lwr_95":-0.22,"upr_95":0.22,"scaled_estimate":0.4975},{"Order":"Oxalidales","Family":"Oxalidales","sp_count":26,"obs_count":67,"bio_count":15,"fam":"Oxalidales","estimate":-0.39,"lwr_95":-2.03,"upr_95":1.38,"scaled_estimate":0.4037},{"Order":"Passeriformes","Family":"Passeriformes","sp_count":1744,"obs_count":3970,"bio_count":46,"fam":"Passeriformes","estimate":0.74,"lwr_95":0.45,"upr_95":1.06,"scaled_estimate":0.677},{"Order":"Pectinida","Family":"Pectinida","sp_count":11,"obs_count":17,"bio_count":5,"fam":"Pectinida","estimate":-0.67,"lwr_95":-1.95,"upr_95":0.74,"scaled_estimate":0.3385},{"Order":"Pelecaniformes","Family":"Pelecaniformes","sp_count":82,"obs_count":451,"bio_count":40,"fam":"Pelecaniformes","estimate":-0.93,"lwr_95":-1.46,"upr_95":-0.43,"scaled_estimate":0.2829},{"Order":"Perciformes","Family":"Perciformes","sp_count":602,"obs_count":773,"bio_count":24,"fam":"Perciformes","estimate":0.57,"lwr_95":-0.24,"upr_95":1.39,"scaled_estimate":0.6388},{"Order":"Phyllodocida","Family":"Phyllodocida","sp_count":24,"obs_count":24,"bio_count":1,"fam":"Phyllodocida","estimate":0.02,"lwr_95":-0.21,"upr_95":0.25,"scaled_estimate":0.505},{"Order":"Piciformes","Family":"Piciformes","sp_count":135,"obs_count":260,"bio_count":35,"fam":"Piciformes","estimate":-1.09,"lwr_95":-1.89,"upr_95":-0.32,"scaled_estimate":0.2516},{"Order":"Pinales","Family":"Pinales","sp_count":121,"obs_count":276,"bio_count":22,"fam":"Pinales","estimate":1,"lwr_95":0.18,"upr_95":1.77,"scaled_estimate":0.7311},{"Order":"Plecoptera","Family":"Plecoptera","sp_count":23,"obs_count":40,"bio_count":3,"fam":"Plecoptera","estimate":-0.05,"lwr_95":-0.65,"upr_95":0.54,"scaled_estimate":0.4875},{"Order":"Pleuronectiformes","Family":"Pleuronectiformes","sp_count":14,"obs_count":21,"bio_count":5,"fam":"Pleuronectiformes","estimate":0.4,"lwr_95":-0.72,"upr_95":1.32,"scaled_estimate":0.5987},{"Order":"Poales","Family":"Poales","sp_count":717,"obs_count":1632,"bio_count":21,"fam":"Poales","estimate":-0.18,"lwr_95":-1.12,"upr_95":0.71,"scaled_estimate":0.4551},{"Order":"Podicipediformes","Family":"Podicipediformes","sp_count":14,"obs_count":89,"bio_count":32,"fam":"Podicipediformes","estimate":-1.08,"lwr_95":-1.96,"upr_95":-0.16,"scaled_estimate":0.2535},{"Order":"Polydesmida","Family":"Polydesmida","sp_count":14,"obs_count":16,"bio_count":3,"fam":"Polydesmida","estimate":-0.43,"lwr_95":-2.31,"upr_95":1.47,"scaled_estimate":0.3941},{"Order":"Polypodiales","Family":"Polypodiales","sp_count":73,"obs_count":214,"bio_count":16,"fam":"Polypodiales","estimate":-0.09,"lwr_95":-0.67,"upr_95":0.57,"scaled_estimate":0.4775},{"Order":"Primates","Family":"Primates","sp_count":36,"obs_count":49,"bio_count":15,"fam":"Primates","estimate":-0.56,"lwr_95":-1.92,"upr_95":0.86,"scaled_estimate":0.3635},{"Order":"Procellariiformes","Family":"Procellariiformes","sp_count":40,"obs_count":84,"bio_count":14,"fam":"Procellariiformes","estimate":0.27,"lwr_95":-0.39,"upr_95":0.93,"scaled_estimate":0.5671},{"Order":"Proteales","Family":"Proteales","sp_count":69,"obs_count":75,"bio_count":6,"fam":"Proteales","estimate":1.34,"lwr_95":-0.39,"upr_95":2.83,"scaled_estimate":0.7925},{"Order":"Psittaciformes","Family":"Psittaciformes","sp_count":90,"obs_count":118,"bio_count":25,"fam":"Psittaciformes","estimate":-0.11,"lwr_95":-1.82,"upr_95":1.68,"scaled_estimate":0.4725},{"Order":"Ranunculales","Family":"Ranunculales","sp_count":178,"obs_count":474,"bio_count":21,"fam":"Ranunculales","estimate":1.39,"lwr_95":0.79,"upr_95":1.96,"scaled_estimate":0.8006},{"Order":"Rodentia","Family":"Rodentia","sp_count":195,"obs_count":359,"bio_count":37,"fam":"Rodentia","estimate":1.25,"lwr_95":0.26,"upr_95":2.14,"scaled_estimate":0.7773},{"Order":"Rosales","Family":"Rosales","sp_count":365,"obs_count":996,"bio_count":27,"fam":"Rosales","estimate":1.19,"lwr_95":0.05,"upr_95":2.16,"scaled_estimate":0.7667},{"Order":"Sabellida","Family":"Sabellida","sp_count":26,"obs_count":40,"bio_count":6,"fam":"Sabellida","estimate":-0.18,"lwr_95":-1.87,"upr_95":1.52,"scaled_estimate":0.4551},{"Order":"Salmoniformes","Family":"Salmoniformes","sp_count":14,"obs_count":41,"bio_count":10,"fam":"Salmoniformes","estimate":0.52,"lwr_95":-0.61,"upr_95":1.58,"scaled_estimate":0.6271},{"Order":"Santalales","Family":"Santalales","sp_count":24,"obs_count":35,"bio_count":9,"fam":"Santalales","estimate":0.38,"lwr_95":-1.06,"upr_95":1.8,"scaled_estimate":0.5939},{"Order":"Sapindales","Family":"Sapindales","sp_count":117,"obs_count":283,"bio_count":24,"fam":"Sapindales","estimate":2.26,"lwr_95":1.11,"upr_95":3.3,"scaled_estimate":0.9055},{"Order":"Saxifragales","Family":"Saxifragales","sp_count":118,"obs_count":263,"bio_count":16,"fam":"Saxifragales","estimate":1.68,"lwr_95":0.89,"upr_95":2.41,"scaled_estimate":0.8429},{"Order":"Scleractinia","Family":"Scleractinia","sp_count":32,"obs_count":32,"bio_count":2,"fam":"Scleractinia","estimate":-0.05,"lwr_95":-0.93,"upr_95":0.9,"scaled_estimate":0.4875},{"Order":"Scorpaeniformes","Family":"Scorpaeniformes","sp_count":34,"obs_count":45,"bio_count":6,"fam":"Scorpaeniformes","estimate":-0.2,"lwr_95":-0.96,"upr_95":0.54,"scaled_estimate":0.4502},{"Order":"Siluriformes","Family":"Siluriformes","sp_count":10,"obs_count":17,"bio_count":6,"fam":"Siluriformes","estimate":0.32,"lwr_95":-1.2,"upr_95":1.67,"scaled_estimate":0.5793},{"Order":"Solanales","Family":"Solanales","sp_count":79,"obs_count":256,"bio_count":25,"fam":"Solanales","estimate":0.18,"lwr_95":-1.02,"upr_95":1.26,"scaled_estimate":0.5449},{"Order":"Soricomorpha","Family":"Soricomorpha","sp_count":23,"obs_count":41,"bio_count":11,"fam":"Soricomorpha","estimate":0.7,"lwr_95":-0.3,"upr_95":1.59,"scaled_estimate":0.6682},{"Order":"Spionida","Family":"Spionida","sp_count":22,"obs_count":22,"bio_count":1,"fam":"Spionida","estimate":-0.11,"lwr_95":-0.55,"upr_95":0.35,"scaled_estimate":0.4725},{"Order":"Squaliformes","Family":"Squaliformes","sp_count":10,"obs_count":12,"bio_count":3,"fam":"Squaliformes","estimate":0.15,"lwr_95":-1.04,"upr_95":1.07,"scaled_estimate":0.5374},{"Order":"Squamata","Family":"Squamata","sp_count":564,"obs_count":793,"bio_count":35,"fam":"Squamata","estimate":-0.81,"lwr_95":-1.64,"upr_95":0.05,"scaled_estimate":0.3079},{"Order":"Stolidobranchia","Family":"Stolidobranchia","sp_count":12,"obs_count":19,"bio_count":4,"fam":"Stolidobranchia","estimate":-0.41,"lwr_95":-2.06,"upr_95":1.33,"scaled_estimate":0.3989},{"Order":"Strigiformes","Family":"Strigiformes","sp_count":48,"obs_count":124,"bio_count":31,"fam":"Strigiformes","estimate":-0.18,"lwr_95":-1.05,"upr_95":0.71,"scaled_estimate":0.4551},{"Order":"Stylommatophora","Family":"Stylommatophora","sp_count":90,"obs_count":206,"bio_count":14,"fam":"Stylommatophora","estimate":0.68,"lwr_95":-0.73,"upr_95":1.91,"scaled_estimate":0.6637},{"Order":"Suliformes","Family":"Suliformes","sp_count":35,"obs_count":113,"bio_count":38,"fam":"Suliformes","estimate":0,"lwr_95":-0.99,"upr_95":1.04,"scaled_estimate":0.5},{"Order":"Syngnathiformes","Family":"Syngnathiformes","sp_count":11,"obs_count":13,"bio_count":4,"fam":"Syngnathiformes","estimate":-0.44,"lwr_95":-1.85,"upr_95":0.98,"scaled_estimate":0.3917},{"Order":"Terebellida","Family":"Terebellida","sp_count":13,"obs_count":15,"bio_count":2,"fam":"Terebellida","estimate":0.2,"lwr_95":-1.03,"upr_95":1.26,"scaled_estimate":0.5498},{"Order":"Testudines","Family":"Testudines","sp_count":42,"obs_count":94,"bio_count":26,"fam":"Testudines","estimate":-0.86,"lwr_95":-2.33,"upr_95":0.61,"scaled_estimate":0.2973},{"Order":"Tetraodontiformes","Family":"Tetraodontiformes","sp_count":54,"obs_count":66,"bio_count":9,"fam":"Tetraodontiformes","estimate":-0.56,"lwr_95":-1.4,"upr_95":0.29,"scaled_estimate":0.3635},{"Order":"Trichoptera","Family":"Trichoptera","sp_count":83,"obs_count":137,"bio_count":4,"fam":"Trichoptera","estimate":-0.13,"lwr_95":-0.66,"upr_95":0.5,"scaled_estimate":0.4675},{"Order":"Trochida","Family":"Trochida","sp_count":14,"obs_count":20,"bio_count":4,"fam":"Trochida","estimate":0.6,"lwr_95":-0.63,"upr_95":1.83,"scaled_estimate":0.6457},{"Order":"Trogoniformes","Family":"Trogoniformes","sp_count":17,"obs_count":18,"bio_count":7,"fam":"Trogoniformes","estimate":0.17,"lwr_95":-0.79,"upr_95":1.27,"scaled_estimate":0.5424},{"Order":"Unionida","Family":"Unionida","sp_count":11,"obs_count":15,"bio_count":4,"fam":"Unionida","estimate":0.69,"lwr_95":-0.54,"upr_95":1.7,"scaled_estimate":0.666},{"Order":"Venerida","Family":"Venerida","sp_count":33,"obs_count":48,"bio_count":7,"fam":"Venerida","estimate":0.17,"lwr_95":-0.88,"upr_95":1.2,"scaled_estimate":0.5424},{"Order":"Vitales","Family":"Vitales","sp_count":10,"obs_count":25,"bio_count":8,"fam":"Vitales","estimate":-0.25,"lwr_95":-2.09,"upr_95":1.59,"scaled_estimate":0.4378}]

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

module.exports = {"main":"((Lycopodiaceae,(((Lauraceae,(((Proteaceae,(((Vitaceae,(((Celastraceae,(Oxalidaceae,((Phyllanthaceae,(Euphorbiaceae,Linaceae)),(Hypericaceae,(Salicaceae,Violaceae))))),(((Rosaceae,(Rhamnaceae,(Ulmaceae,(Cannabaceae,(Moraceae,Urticaceae))))),(Cucurbitaceae,(Betulaceae,Fagaceae))),(Fabaceae,Polygalaceae))),(((Anacardiaceae,(Rutaceae,Sapindaceae)),(Brassicaceae,(Cistaceae,(Thymelaeaceae,Malvaceae)))),(Geraniaceae,(Myrtaceae,(Onagraceae,Lythraceae)))))),((Crassulaceae,Haloragaceae),(Saxifragaceae,Grossulariaceae))),(Santalaceae,((Cornaceae,((((Boraginaceae,(Oleaceae,((Plantaginaceae,Scrophulariaceae),(Bignoniaceae,(Lentibulariaceae,(Verbenaceae,(Lamiaceae,(Orobanchaceae,Phrymaceae)))))))),((Convolvulaceae,Solanaceae),(Rubiaceae,(Apocynaceae,Gentianaceae)))),(Aquifoliaceae,((Campanulaceae,(Asteraceae,Goodeniaceae)),((Pittosporaceae,(Apiaceae,Araliaceae)),(Caprifoliaceae,Adoxaceae))))),(Polemoniaceae,(Primulaceae,Ericaceae)))),((Caryophyllaceae,Amaranthaceae),(Polygonaceae,Plumbaginaceae)))))),(Papaveraceae,(Ranunculaceae,Berberidaceae))),((((Arecaceae,(Typhaceae,(Poaceae,(Juncaceae,Cyperaceae)))),(Orchidaceae,(Iridaceae,(Asphodelaceae,(Amaryllidaceae,Asparagaceae))))),(Melanthiaceae,Liliaceae)),(Araceae,Potamogetonaceae)))),(Cupressaceae,Pinaceae)),(Dryopteridaceae,(Blechnaceae,Aspleniaceae)))),(((Asteriidae,(Styelidae,((((((Cercopithecidae,(Leporidae,(Sciuridae,(Heteromyidae,(Muridae,Cricetidae))))),(Soricidae,((Vespertilionidae,(Delphinidae,(Cervidae,Bovidae))),(Mustelidae,Canidae)))),(Macropodidae,Dasyuridae)),((Emydidae,((((Rallidae,((Accipitridae,((Falconidae,(Psittacidae,((((Petroicidae,((((Troglodytidae,Sittidae),((Muscicapidae,Turdidae),(Sturnidae,Mimidae))),(Nectariniidae,(Ploceidae,(Estrildidae,(Passeridae,(Motacillidae,(Fringillidae,((Thraupidae,Cardinalidae),(Emberizidae,(Parulidae,Icteridae)))))))))),(Paridae,(Alaudidae,(Cisticolidae,(Acrocephalidae,((Phylloscopidae,(Sylviidae,(Leiothrichidae,Zosteropidae))),(Hirundinidae,Pycnonotidae)))))))),(((Dicruridae,(Monarchidae,(Corvidae,Laniidae))),(Malaconotidae,Campephagidae)),(Vireonidae,Pachycephalidae))),(Maluridae,(Meliphagidae,Acanthizidae))),((Furnariidae,Thamnophilidae),(Tyrannidae,(Pipridae,Cotingidae)))))),(Strigidae,(Trogonidae,(Bucerotidae,((Picidae,Ramphastidae),(Alcedinidae,Meropidae))))))),((Podicipedidae,(Charadriidae,(Scolopacidae,(Laridae,Alcidae)))),(Procellariidae,(Ciconiidae,(Phalacrocoracidae,(Ardeidae,Threskiornithidae))))))),(Columbidae,(Musophagidae,(Otididae,Cuculidae)))),(Trochilidae,Apodidae)),(Anatidae,(Phasianidae,Cracidae)))),((Scincidae,(((Viperidae,(Elapidae,(Colubridae,(Dipsadidae,Natricidae)))),(Varanidae,(Agamidae,(Dactyloidae,Phrynosomatidae)))),(Teiidae,Lacertidae))),(Gekkonidae,(Diplodactylidae,Pygopodidae))))),((Ranidae,((Hylidae,Bufonidae),(Limnodynastidae,Myobatrachidae))),(Salamandridae,Plethodontidae))),(Cyprinidae,(Salmonidae,(Macrouridae,(Holocentridae,(Gobiidae,(((Carangidae,(Pomacentridae,Blenniidae)),((((Sparidae,(Tetraodontidae,(Monacanthidae,Balistidae))),(Acanthuridae,(Chaetodontidae,(Lutjanidae,Pomacanthidae)))),(Scaridae,Labridae)),(Serranidae,(Centrarchidae,Kyphosidae)))),(Syngnathidae,Mullidae)))))))))),((((Trochidae,((Buccinidae,Muricidae),(Chromodorididae,Planorbidae))),(Unionidae,(Cardiidae,Veneridae))),(Syllidae,(Lumbricidae,(Sabellidae,Spionidae)))),((Julidae,(Palaemonidae,(Entomobryidae,((Baetidae,(((((((Nepticulidae,(Adelidae,(Tineidae,(Argyresthiidae,(((((Drepanidae,(Geometridae,((Notodontidae,((Arctiidae,Erebidae),(Nolidae,Noctuidae))),(Lasiocampidae,(Sphingidae,Saturniidae))))),(Crambidae,Pyralidae)),(Pterophoridae,(Papilionidae,(Hesperiidae,(Pieridae,(Nymphalidae,Lycaenidae)))))),(Elachistidae,Oecophoridae,(Coleophoridae,Gelechiidae))),(Tortricidae,(Sesiidae,(Limacodidae,Zygaenidae)))),(Gracillariidae,(Yponomeutidae,Ypsolophidae)))))),(Leptoceridae,Limnephilidae)),(((Cecidomyiidae,(((Syrphidae,((Muscidae,(Anthomyiidae,(Sarcophagidae,(Tachinidae,Calliphoridae)))),(Tephritidae,(Sciomyzidae,Lauxaniidae)))),(Dolichopodidae,(Hybotidae,Empididae))),(Tabanidae,(Stratiomyidae,(Asilidae,Bombyliidae))))),(Chironomidae,Culicidae)),(Limoniidae,Tipulidae))),((((Anobiidae,((Tenebrionidae,(Nitidulidae,((Curculionidae,(Apionidae,Brentidae)),(Chrysomelidae,Cerambycidae)))),(Coccinellidae,Latridiidae))),(Buprestidae,(Elateridae,Cantharidae))),((Leiodidae,(Silphidae,Staphylinidae)),(Hydrophilidae,(Cetoniidae,Scarabaeidae,Aphodiidae)))),((Carabidae,Brachyceridae),(Dytiscidae,Haliplidae)))),(Tenthredinidae,(Cynipidae,((Formicidae,(Sphecidae,(Crabronidae,((Apidae,Megachilidae),(Andrenidae,(Colletidae,Halictidae)))))),(Pompilidae,(Eumenidae,Vespidae)))))),(Aphididae,(((Miridae,Reduviidae),(Pentatomidae,Coreidae,(Rhyparochromidae,Lygaeidae))),(Cicadellidae,Cicadidae)))),(Mantidae,(Acrididae,(Tettigoniidae,Gryllidae))))),((Calopterygidae,Coenagrionidae,Lestidae),(Aeshnidae,(Gomphidae,(Libellulidae,Corduliidae)))))))),((Lycosidae,(Clubionidae,(Thomisidae,(Salticidae,Philodromidae)))),(Dictynidae,(Linyphiidae,Theridiidae,Tetragnathidae,Araneidae)))))),(Agariciidae,Actiniidae)));"}

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

module.exports = fetch;

/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(237)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(254),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PhyloTree__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PhyloTree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PhyloTree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyMenu__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MyMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_MyMenu__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    PhyloTree: __WEBPACK_IMPORTED_MODULE_0__components_PhyloTree___default.a,
    MyMenu: __WEBPACK_IMPORTED_MODULE_1__components_MyMenu___default.a
  },
  mounted: function mounted() {
    if (!localStorage.getItem('tutorial_completed')) {
      window.introJS().start();
      localStorage.setItem('tutorial_completed', 'true');
    }
  }
});

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'attribution'
});

/***/ }),

/***/ 97:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'my-header',
  props: ['main', 'sub'],
  computed: {
    link: function link() {
      return 'https://en.wikipedia.org/wiki/' + this.main;
    }
  }
});

/***/ }),

/***/ 98:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'my-menu',
  data: function data() {
    return {
      showWelcome: false
    };
  },

  methods: {
    tutorial: function tutorial() {
      var _this = this;

      this.showWelcome = true;
      this.$nextTick(function () {
        window.introJS().start().onexit(function () {
          _this.showWelcome = false;
        });
      });
    }
  },
  mounted: function mounted() {
    document.documentElement.setAttribute('data-theme', 'light');
  }
});

/***/ }),

/***/ 99:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_d3_tree__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_d3_tree___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vue_d3_tree__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WikiSummary__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WikiSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__WikiSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Attribution__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Attribution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Attribution__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Header__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wikijs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_wikijs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_wikijs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tree_trees__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tree_trees___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_tree_trees__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components





var wikiApi = __WEBPACK_IMPORTED_MODULE_7_wikijs___default()({ apiUrl: 'https://en.wikipedia.org/w/api.php' });
// Tree data

// think of a better name
var parseNewick = __webpack_require__(102);

var trees = {};
__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_8_tree_trees___default.a).forEach(function (x) {
  trees[x] = parseNewick.parseNewick(__WEBPACK_IMPORTED_MODULE_8_tree_trees___default.a[x]);
});

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'phylo-tree',
  data: function data() {
    return {
      treeData: trees.main,
      selectedPerson: 'main',
      selectedLeaf: '',
      people: {
        lwr_95: 0,
        estimate: 0,
        upr_95: 0
      },
      selectedTree: 'main',
      seen: parseNewick.seen,
      hoveredNode: null,
      hoveredImage: null,
      hoveredSummary: null,
      hoveredTaxonomy: '',
      mouseX: 0,
      mouseY: 0,
      hoverTimeout: null
    };
  },

  methods: {
    hover: function hover(event) {
      var _this = this;

      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }

      if (event.active) {
        this.mouseX = event.event.clientX;
        this.mouseY = event.event.clientY;

        // Show text immediately
        this.hoveredNode = event.data;
        this.hoveredImage = null;
        this.hoveredSummary = null;
        this.updateHoverTaxonomy(event.data.name);

        // Delay Wikipedia API requests
        this.hoverTimeout = setTimeout(function () {
          _this.updateHoverWiki(event.data.name);
        }, 500);
      } else {
        this.hoveredNode = null;
        this.hoveredImage = null;
        this.hoveredSummary = null;
        this.hoveredTaxonomy = '';
      }
    },
    updateHoverTaxonomy: function updateHoverTaxonomy(name) {
      if (!name || name.match(/ott/)) return;

      var d = this.seen[name];
      if (d) {
        var match = d.Family ? d.Family.match(/\((.*)\)/) : null;
        var common = match ? match[1] : '';
        this.hoveredTaxonomy = 'Order: ' + d.Order + (common ? ' | Common: ' + common : '');
      }
    },
    updateHoverWiki: function updateHoverWiki(name) {
      var _this2 = this;

      if (!name || name.match(/ott/)) return;

      wikiApi.page(name).then(function (page) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([page.mainImage(), page.summary()]).then(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              image = _ref2[0],
              summary = _ref2[1];

          if (_this2.hoveredNode && _this2.hoveredNode.name === name) {
            _this2.hoveredImage = image;
            _this2.hoveredSummary = summary.length > 150 ? summary.substring(0, 150) + '...' : summary;
          }
        });
      }).catch(function () {});
    },
    updateHoverInfo: function updateHoverInfo(name) {
      // Deprecated in favor of split taxonomy/wiki updates
    },

    clicked: function clicked(x) {
      var name = x.data.name;
      var d = this.seen[name];
      if (d) {
        this.people.lwr_95 = d.lwr_95;
        this.people.estimate = d.estimate;
        this.people.upr_95 = d.upr_95;
      } else {
        // Reset or handle missing data for orders/groups
        this.people.lwr_95 = 0;
        this.people.estimate = 0;
        this.people.upr_95 = 0;
      }

      this.$scrollTo('#summary');

      this.selectedLeaf = name;
    },
    notNullColor: function notNullColor(d) {
      return function (x) {
        return '#F00';
      };
      // d3.scaleOrdinal()
      //  .domain(['Bacteria', 'Eukaryota', 'Archaea'])
      //  .range(d3.schemeCategory10)
    }
  },
  watch: {
    selectedTree: function selectedTree(newValue) {
      this.selectedLeaf = '';
      this.treeData = trees[newValue];
    }
  },
  computed: {
    common: function common() {
      var d = this.seen[this.selectedLeaf];
      if (d && d.Family) {
        var match = d.Family.match(/\((.*)\)/);
        var c = match ? match[1] : d.Family;
        return 'Higher Taxonomy: ' + d.Order + ' | Common: ' + c;
      }
      return '';
    },
    cardStyle: function cardStyle() {
      var xOffset = 20;
      var yOffset = 20;
      var margin = 10;
      var top = this.mouseY + yOffset;

      // If card would overflow bottom, shift it up
      if (this.$refs.floatingCard) {
        var height = this.$refs.floatingCard.offsetHeight;
        if (top + height > window.innerHeight - margin) {
          top = window.innerHeight - height - margin;
        }
      }

      return {
        left: this.mouseX + xOffset + 'px',
        top: top + 'px',
        position: 'fixed',
        zIndex: 1000,
        pointerEvents: 'none',
        width: '250px'
      };
    }
  },
  components: {
    tree: __WEBPACK_IMPORTED_MODULE_3__vue_d3_tree__["tree"],
    attribution: __WEBPACK_IMPORTED_MODULE_5__Attribution___default.a,
    WikiSummary: __WEBPACK_IMPORTED_MODULE_4__WikiSummary___default.a,
    myHeader: __WEBPACK_IMPORTED_MODULE_6__Header___default.a
  }
});

/***/ })

},[108]);


// WEBPACK FOOTER //
// static/js/app.972a5e9bc3057b02b4f9.js